import { addressList } from './styles/addressList';
import { alert } from './styles/alert';
import { alertBar } from './styles/alertBar';
import { articleCard } from './styles/articleCard';
import { assembleHelp } from './styles/assembleHelp';
import { autocomplete } from './styles/autocomplete';
import { button } from './styles/button';
import { countdown } from './styles/countdown';
import { dialog } from './styles/dialog';
import { drawer, drawerHeader } from './styles/drawer';
import {
  editablePanelSummaryActions,
  editablePanelRadio,
  editablePanelSummary,
  editablePanelDetails,
  editablePanelActions,
  editablePanel,
} from './styles/editablePanel';
import { estimatedArrival } from './styles/estimatedArrival';
import { figureCard, figureGrid, figureSelector } from './styles/figure';
import { fixedMobileCTA } from './styles/fixedMobileCTA';
import { fluidImage } from './styles/fluidImage';
import { gallery } from './styles/gallery';
import { giftList } from './styles/giftList';
import { giftOverlay } from './styles/giftOverlay';
import { iconButton } from './styles/iconButton';
import { image } from './styles/image';
import { infoCard, infoCards } from './styles/infoCards';
import { input } from './styles/input';
import { link, linkButton } from './styles/link';
import { logo } from './styles/logo';
import { profileButton } from './styles/profileButton';
import { mobileSlider } from './styles/mobileSlider';
import { module } from './styles/module';
import { nextGift } from './styles/nextGift';
import { nextPackageDetails } from './styles/nextPackageDetails';
import { overlay } from './styles/overlay';
import { payment, paymentList } from './styles/payment';
import { playButton } from './styles/playButton';
import { profileElement } from './styles/profileElement';
import { progress } from './styles/progress';
import { select } from './styles/select';
import { socialBox } from './styles/socialBox';
import { stamp } from './styles/stamp';
import { text } from './styles/text';
import { statusChip } from './styles/statusChip';
import { video, videoDescription } from './styles/video';
import { ribbon } from './styles/ribbon';
import { slider } from './styles/slider';

const subscriptionHeader = (theme) => ({
  /* Styles applied to the root element. */
  root: {},
  title: {},
  container: {
    display: 'flex',
  },
  label: {
    marginRight: theme.spacing(3),
  },
  value: {},
  status: {
    marginLeft: theme.spacing(2),
  },
});

const topSpacing = (theme) => ({
  topSpacing: {
    height: theme.spacing(3),
    flex: `0 0 ${theme.spacing(3)}px`,
    backgroundColor: theme.customPalette.neutralGr02,
    [theme.breakpoints.up('md')]: {
      height: 0,
      flex: `0 0 0`,
    },
  },
});

const complexItemCard = (theme) => ({
  itemCard: {
    background: 'inherit',
    height: 400,
    textAlign: 'center',
    border: 'none',
    [theme.breakpoints.down('md')]: {
      height: 'unset',
    },
  },
  itemCardMedia: {
    height: 365,

    [theme.breakpoints.down('sm')]: {
      height: 'unset',
    },
  },
  videoClass: {
    width: 487,
    height: 365,
    '@media screen and (min-width: 960px) and (max-width: 1280px)': {
      width: 487,
      height: 313,
    },
    '@media screen and (min-width: 600px) and (max-width: 960px)': {
      height: 'calc(75vw - 88px)',
      marginTop: 48,
      width: '100%',
    },
    '@media screen and (max-width: 600px)': {
      height: 'calc(75vw - 88px)',
      marginTop: 0,
      width: '100%',
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  imageContainer: {
    margin: 8,
  },
  cardContentRoot: {
    padding: 0,
  },
});

const packageHeader = (theme) => ({
  fieldTitle: {
    color: theme.customPalette.neutralGr04,
  },
});

const packageItemCard = (theme) => ({
  itemCard: {
    position: 'relative',
    overflow: 'hidden',
    background: 'inherit',
    minHeight: '220px',
    textAlign: 'center',
    border: 'none',
    backgroundColor: theme.customPalette.neutralGr01,
  },
  itemCardModel: {
    position: 'relative',
    overflow: 'hidden',
    background: 'inherit',
    minHeight: '220px',
    textAlign: 'center',
    border: 'none',
    backgroundColor: theme.customPalette.neutralGr01,
    marginLeft: '4px',
    marginRight: '4px',
  },
  ribbon: {
    position: 'absolute',
    top: '45px',
    right: '-70px',
    transform: 'rotate(45deg)',
    background: '#2f63d6',
    color: '#fff',
    fontSize: '10px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    width: '250px',
    textAlign: 'center',
    padding: '0',
    zIndex: 2,
  },
  itemCardMedia: {
    height: '160px',
    backgroundSize: 'contain',
    paddingTop: '16px',
    backgroundOrigin: 'content-box',

    backgroundPosition: 'center',
  },
  itemCardMediaMissing: {
    height: '160px',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    opacity: '.4',
    filter: 'grayscale(100%)',
  },
  itemCardMediaPlaceholder: {
    margin: '0 auto',
  },
  name: {
    fontSize: '12px',
    fontWeight: '500',
    color: theme.customPalette.neutralGr05,
    lineHeight: 1,
  },
  sequence: {
    fontSize: '10px',
    fontWeight: '500',
    color: theme.customPalette.neutralGy05,
    lineHeight: 1,
  },
  cardPadding: {
    paddingTop: '8px',
    paddingBottom: '0 !important',
    paddingLeft: 16,
    paddingRight: 16,
  },
  magazine: {
    width: '100%',
    marginTop: 16,
    color: `${theme.customPalette.grapePurple} !important`,
  },
  markedBtn: {
    marginTop: 16,
    backgroundColor: 'transparent',
    color: theme.customPalette.secondaryYellowYButtons,
    fontSize: 12,
    border: 'None',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  markedBtnActive: {
    textTransform: 'uppercase',
    fontFamily: 'Spezia',
    display: 'block',
    marginTop: 16,
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 100,
    borderBottom: '2px solid' + theme.customPalette.neutralGy05,
  },
});

const nextPackage = (theme) => ({
  root: {
    width: '100%',
  },
  expansion: {
    background: 'inherit',
  },
  expansionSummaryRoot: {
    '& .MuiIconButton-root': {
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
      },
    },
  },
  expansionSummaryContent: {
    marginTop: 0,
    marginBottom: 0,
    transition: 'none',
    '&$expanded': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  titleAssemblyContainer: {
    marginBottom: 24,
    marginTop: 16,
  },
  selected: {
    color: theme.customPalette.black,
  },
  unselected: {
    color: theme.customPalette.neutralGr02,
    [theme.breakpoints.down('sm')]: {
      color: '#999999',
    },
  },
  selectedArrow: {
    marginRight: 0,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  rotateUp: {
    '-webkit-transform': 'rotate(-90deg)',
    '-ms-transform': 'rotate(-90deg)',
    transform: 'rotate(-90deg)',
  },
  rotateDown: {
    '-webkit-transform': 'rotate(90deg)',
    '-ms-transform': 'rotate(90deg)',
    transform: 'rotate(90deg)',
  },
  imageOverride: {
    [theme.breakpoints.down('sm')]: {
      width: '24px!important',
      height: '24px!important',
    },
  },
  unselectedArrow: {
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  arrowSliderContainer: {
    cursor: 'pointer',
    paddingTop: 14,
    paddingBottom: 14,
    borderBottom: `1px solid ${theme.customPalette.neutralGr04}`,
    [theme.breakpoints.down('sm')]: {
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  hideOnMobile: {
    display: 'initial',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  expanded: {},
  details: {
    borderTop: `1px solid ${theme.customPalette.neutralGr01}`,
    padding: 0,
    flexDirection: 'column',
  },
  subscriptionLinkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      paddingTop: '18px!important',
      paddingBottom: '18px!important',
    },
  },
  statusDetailsWrapper: {},
  spacingHeader: {
    '& .MuiGrid-item': {
      padding: theme.spacing(2, 1, 1, 1),
    },
  },
  spacingBody: {
    '&>.MuiGrid-item': {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      '&>.MuiGrid-item': {
        padding: theme.spacing(2),
      },
    },
  },
  headerVerticalDivider: {
    [theme.breakpoints.up('md')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  headerVerticalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  headerHorizontalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  bodyVerticalDivider: {
    [theme.breakpoints.up('md')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyVerticalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyHorizontalDivider: {
    [theme.breakpoints.up('md')]: {
      borderTop: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyHorizontalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderTop: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  assemblyBody: {
    [theme.breakpoints.down('sm')]: {},
  },
  trackingUrl: {
    '& p': {
      color: theme.customPalette.secondaryYellowYButtons,
      fontSize: '10px',
      fontWeight: 'bold',
      border: 'none',
      textTransform: 'capitalize',
    },
  },
  gift: {
    [theme.breakpoints.down('md')]: {
      marginBottom: '0!important',
    },
  },
  giftContainer: {
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '24px 0 0 0',
    },
  },
  giftTitle: {
    [theme.breakpoints.down('md')]: {
      padding: '0 16px 0 16px',
    },
  },
  progressWrapper: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  flexLeftCard: {
    display: 'flex',
    height: 365,
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      height: 'unset',
    },
  },
});

const notification = (theme) => ({
  notificationWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  notification: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: '#fff',
    background: theme.customPalette.secondaryPinkP02,
    border: `1px solid ${theme.customPalette.secondaryPinkP02}`,
    width: '100%',
  },
  notificationMissingIssue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: '#fff',
    background: theme.customPalette.secondaryBlueB02,
    border: `1px solid ${theme.customPalette.secondaryBlueB02}`,
    width: '100%',
    padding: '8px',
  },
  notificationIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    minWidth: 48,
    marginLeft: -1,
  },
  notificationIcon: {
    width: 24,
    height: 24,
  },
  notificationText: {
    padding: theme.spacing(1),
    height: 'unset',
    color: '#fff',
    fontSize: 14,
    fontFamily: 'Spezia',
    lineHeight: 1.14,
    fontWeight: 'normal',
  },
  notificationMissingText: {
    padding: theme.spacing(1),
    height: 'unset',
    color: '#fff',
    fontSize: 12,
    fontFamily: 'Spezia',
    lineHeight: 1.14,
    fontWeight: '500',
  },
});

const packagePackage = (theme) => ({
  root: {
    width: '100%',
    marginBottom: '0px !important',
    fontFamily: 'Spezia',
  },
  modelAccordionSummary: {
    position: 'absolute',
    top: '100%',
    left: 0,
    minHeight: '48px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
    border: '1px solid' + theme.customPalette.neutralGr03,
    borderTop: 'none',
    width: '100%',
  },
  sectionTitle: {
    margin: theme.spacing(6, 0, 5, 0),
    fontFamily: 'Spezia',
  },
  wrapper: {
    display: 'flex',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  accordionStyle: {},
  accordionSummary: {
    fontFamily: 'Spezia',
    border: '0.5px solid' + theme.customPalette.neutralGr04,
  },
  accordionDetails: {
    border: '0.5px solid' + theme.customPalette.neutralGr04,
    borderTop: 'none',
    padding: '0',
  },
  buttonCustom: {
    backgroundColor: 'transparent',
    border: '1px solid' + theme.customPalette.secondaryYellowYButtons,
    height: '40px',
    maxWidth: '225px',
    width: '100%',
    marginTop: 16,
    marginBottom: 16,
    // '& :hover': {
    //   color: '#fff !important',
    // },
  },
  warningNotPaid: {
    backgroundColor: theme.customPalette.secondaryPinkP01,
    padding: '16px',
    color: '#fff',
    '& span': {
      paddingLeft: '16px',
    },
  },
  giftContainer: {
    backgroundColor: theme.customPalette.neutralGr02,
    padding: '24px',
  },
  orderSequence: {
    fontSize: '20px',
    fontWeight: 500,
  },
  mainTitle: {
    color: theme.customPalette.black,
    fontSize: '20px',
    fontWeight: 600,
  },
  tangerineUnderline: {
    margin: '28px 0',
    cursor: 'pointer',
  },

  iconDownload: {
    width: '22px',
    height: '22px',
    filter:
      'brightness(0) saturate(100%) invert(20%) sepia(53%) saturate(2487%) hue-rotate(271deg) brightness(92%) contrast(92%)',
  },
  invoiceText: {
    color: '#fff',
  },
  noPadding: {
    padding: '0!important',
  },
  expansion: {
    background: 'inherit',
  },
  fieldTitle: {
    color: theme.customPalette.neutralGr04,
  },
  expansionSummaryRoot: {
    // "& .MuiIconButton-root": {
    //     [theme.breakpoints.down("sm")]: {
    //         display: "block",
    //         position: "absolute",
    //         right: theme.spacing(1),
    //         top: theme.spacing(1),
    //     },
    // },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflowX: 'scroll',
  },
  expansionSummaryContent: {
    marginTop: 0,
    marginBottom: 0,
    transition: 'none',
    '&$expanded': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  expanded: {},
  details: {
    borderTop: `1px solid ${theme.customPalette.neutralGr01}`,
    padding: 0,
    flexDirection: 'column',
  },
  subscriptionLinkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  statusDetailsWrapper: {},
  spacingHeader: {
    '& .MuiGrid-item': {
      padding: theme.spacing(2, 1, 1, 1),
    },
  },
  spacingBody: {
    '&>.MuiGrid-item': {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      '&>.MuiGrid-item': {
        padding: theme.spacing(1),
      },
    },
  },
  headerVerticalDivider: {
    [theme.breakpoints.up('md')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  headerVerticalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  headerHorizontalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: `1px solid ${theme.customPalette.neutralGr01}`,
    },
  },
  bodyVerticalDivider: {
    [theme.breakpoints.up('md')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyVerticalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyHorizontalDivider: {
    [theme.breakpoints.up('md')]: {
      borderTop: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  bodyHorizontalDividerMobile: {
    [theme.breakpoints.down('sm')]: {
      borderTop: `1px solid ${theme.customPalette.neutralGr02}`,
    },
  },
  trackingUrl: {
    '& p': {
      color: theme.customPalette.secondaryYellowYButtons,
      fontSize: '10px',
      fontWeight: 'bold',
      border: 'none',
      textTransform: 'capitalize',
    },
  },
  orderHeader: {
    backgroundColor: theme.customPalette.neutralGr01,
    paddingTop: '10px',
    paddingBottom: '10px',
    overflowX: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
  },
  progressWrapper: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  paymentStatusWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  paymentAction: {
    maxWidth: '180px',
    width: '100%',
  },
  placeholder: {
    padding: '0px!important',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  totalPopUpContainer: {},
  tooltip: {
    minWidth: 259,
    padding: '16px 12px',
    boxShadow: 'none',
    backgroundColor: 'white',
    border: `1px solid ${theme.customPalette.secondaryPinkP01}`,
    borderRadius: '12px',
    marginTop: '14px',
  },
  tooltipArrow: {
    color: theme.customPalette.secondaryPinkP01,
  },
  icon: {
    height: 16,
    width: 16,
  },
  iconContainer: {
    marginLeft: 10,
    height: 16,
    width: 16,
  },
  dialogContent: {
    margin: 16,
  },
  borders: {
    border: `1px solid ${theme.customPalette.secondaryPinkP01}`,
    borderRadius: '12px',
    padding: '0 16px',
  },
  pointer: {
    cursor: 'pointer',
  },
  itemTooltipList: {
    margin: '4px 0',
    color: theme.customPalette.neutralGy05,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      margin: '16px 0',
    },
  },
  orderInfoLabel: {
    fontSize: '14px',
    fontWeight: '500',
  },
  orderInfoValue: {
    fontSize: '14px',
    fontWeight: 'normal',
  },
  listItem: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  purchasedItem: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: 0,
    paddingBottom: 0,
    '& .MuiListItemText-root': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  price: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    '& .MuiListItemText-primary': {
      fontSize: '14px',
      fontWeight: '500',
      paddingRight: '8px',
      [theme.breakpoints.up('sm')]: {
        fontSize: '12px',
      },
    },
    '& .MuiListItemText-secondary': {
      fontSize: '12px',
      fontWeight: 'normal',
      color: theme.customPalette.neutralGy05,
      display: 'flex',
      textAlign: 'left',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
        textAlign: 'right',
      },
    },
  },
});

const packageStepper = (theme) => ({
  stepper: {
    fontFamily: 'Spezia',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  stepperContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    padding: '0 10px',
    flexGrow: 2,
    alignItems: 'center',
  },
  stepStatus: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '10px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0,
    },
  },
  stepIcon: {
    width: 24,
    height: 24,
  },
  stepLabel: {
    fontWeight: '600',
    fontSize: '16px !important',
  },
  stepDescription: {
    color: theme.customPalette.neutralGy05,
    fontStyle: 'italic',
  },
  stepArrow: {
    cursor: 'pointer',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    '&-prev::before': {
      content: '"< "',
    },
    '&-next::after': {
      content: '" >"',
    },
  },
  trackingUrl: {
    '& p': {
      color: theme.customPalette.secondaryYellowYButtons,
      fontSize: '12px',
      fontWeight: 'bold',
      border: 'none',
      textTransform: 'capitalize',
      // marginBottom: "-5px",
    },
  },
  desktopContainer: {
    flexWrap: 'nowrap',
  },
  label: {
    whiteSpace: 'nowrap',
    fontFamily: 'Spezia',
    wordBreak: 'break-all',
    fontSize: '10px',
    color: theme.customPalette.neutralGr03,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.650rem',
    },
  },
  labelActive: {
    color: theme.customPalette.black,
  },
});

const packageStatusDetails = (theme) => ({
  fieldTitle: {
    color: theme.customPalette.neutralGr04,
  },
  text: {
    marginTop: 8,
  },
});

const aboutModule = (theme) => ({
  about: {
    marginTop: theme.spacing(1 / 2),
    marginBottom: theme.spacing(1 / 2),
    minHeight: 600,
    alignItems: 'center',
    display: 'flex',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      float: 'initial !important',
    },
  },
  editorialContent: {
    float: 'left',
    width: '40%',
    marginRight: '4%',
    marginTop: 'auto',
    marginBottom: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      color: 'white',
      padding: theme.spacing(4, 4, 0, 4),
      marginRight: 'initial',
    },
  },
  title: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    '&:before': {
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
  },
  text: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
      padding: theme.spacing(4, 0, 0, 0),
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 18,
      lineHeight: 1.22,
    },
  },
  imageWrapper: {
    position: 'relative',
    //overflow: 'hidden',
    float: 'right',
    width: '55%',
  },
  parallaxWrapper: {
    position: 'absolute',
    right: -theme.spacing(8),
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    //maxHeight: 450,
    width: '100%',
    /*bottom: 0,
    left: theme.spacing(8),
    right: '-25vw',
    margin: 'auto',
    height: '100%',
    zIndex: -1,*/
  },
  background: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '90%', // FIX ** to be align with visual...
    zIndex: -1,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  foreground: {
    //height: 650, // FIX ** keep it fluid
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '125%',
    },
  },
  button: {
    marginTop: 24,
    fontSize: 16,
    fontWeight: 500,
    padding: '16px',
  },
});

const assembleVideoBanner = (theme) => ({
  container: {
    minHeight: 160,
    background: 'none',
    width: '100%',
    padding: '40px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 16,
      marginRight: 'auto',
    },
  },
  desktopBackground: {
    zIndex: -1,
    height: 240,
    width: '100%',
    position: 'absolute',
    background: theme.customPalette.neutralGr02,
    [theme.breakpoints.down('sm')]: {
      height: 0,
      background: 'none',
    },
  },
  content: {
    display: 'flex',
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  titleContainer: {},
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  title: {
    fontWeight: 'bold',
    fontSize: 24,
    marginBottom: 32,
    maxWidth: 430,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  button: {
    width: 220,
    minHeight: 48,
    [theme.breakpoints.down('sm')]: {
      marginTop: 32,
      marginBottom: 0,
      width: '100%',
    },
  },
  centered: {
    paddingTop: 16,
    zIndex: 100,
    height: '100%',
    display: 'flex',
    alignItems: 'start',
  },
  videoContainer: {
    margin: 4,
    [theme.breakpoints.down('sm')]: {
      margin: 4,
    },
  },
  videoClass: {
    [theme.breakpoints.up('md')]: {
      height: 256,
    },
    '@media screen and (min-width: 960px) and (max-width: 1280px)': {
      height: 'calc(25vw - 46px)',
    },
    '@media screen and (max-width: 960px)': {
      height: 'calc(75vw - 40px)',
    },
  },
  progressBar: {
    height: '100%',
    margin: 'auto',
  },
  sliderReference: {
    '& .slick-slide': {
      margin: '0 3px',
    },
  },
  videoSlider: {
    margin: '0 3px',
  },
});

const appBar = (theme, drawerWidth) => ({
  appBar: {
    borderBottom: `1px solid ${theme.customPalette.neutralGr02}`,
    backgroundColor: '#fff!important',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    easing: theme.transitions.easing.sharp,
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  logo: {
    width: '100%',
    height: 57,
    paddingTop: 8,
    paddingBottom: 8,
    objectFit: 'contain',
    objectPosition: 'left',
    [theme.breakpoints.down('sm')]: {
      objectPosition: 'center',
      height: '100%',
      maxHeight: '57px',
    },
  },
  logoContainerMobile: {
    flex: 'auto',
    [theme.breakpoints.up('sm')]: {
      flex: 1,
    },
  },
  appBarLink: {
    paddingRight: theme.spacing(3),
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:hover': {},
  },
  topSpace: {
    backgroundColor: `${theme.customPalette.primaryGreenG03} !important`,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3, 0, 2),
    color: 'black',
    // backgroundColor: theme.customPalette.primaryGreenG03,
  },
  hide: {
    display: 'none',
  },
  menu: {
    width: 32,
    height: 32,
  },
  close: {
    width: 32,
    height: 32,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  },
  myAreaHeaderLink: {
    color: '#000',
    cursor: 'pointer',
    '&:visited': { color: '#000' },
  },
});

const paymentResult = (theme) => ({
  mainTitle: {
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'Spezia',
    lineHeight: 1.07,
    textAlign: 'center',
    marginTop: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      // textAlign: 'center',
      fontSize: 18,
    },
    [theme.breakpoints.up('lg')]: {
      width: '60%',
    },
  },
});

const changeAddressModal = (theme) => ({
  modal: {},
  title: {},
  addButtonPlaceholder: {
    width: 1,
    marginRight: 'auto',
  },
  buttonSectionFooter: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
  gridButton: {
    padding: 0 + '!important',
  },
  modalBody: {
    minWidth: `min(60vw, ${theme.breakpoints.values.md}px)`,
    height: '100%',
    padding: theme.spacing(3, 7),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // padding: theme.spacing(7, 2),
    padding: '24px 56px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      padding: theme.spacing(2, 2),
    },
  },
  currentPlanContainer: {},
  borderBottom: {
    borderBottom: '1px solid #E5E5E5',
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: 18,
    marginBottom: theme.spacing(3),
  },
  cancelButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      flexGrow: '1',
    },
  },
  addButton: {
    color: `${theme.customPalette.grapePurple} !important`,
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: 277,
    },
  },
  confirmButton: {
    fontSize: 18,
    fontWeight: 600,
    minWidth: 'auto',
    width: '100%',
    marginLeft: 8,
    color: `${theme.customPalette.grapePurple} !important`,
    '&:disabled': {
      color: `white !important`,
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 218,
    },
  },
  cancelButton: {
    fontSize: 18,
    fontWeight: 600,
    minWidth: 'auto',
    width: '100%',
    padding: '8px 16px 8px 16px',
    marginRight: 8,
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 218,
    },
  },
});

const changePaymentMethodModal = (theme) => ({
  modal: {},
  title: {},
  modalBody: {
    minWidth: `min(60vw, ${theme.breakpoints.values.md}px)`,
    height: '100%',
    padding: theme.spacing(3, 7),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // padding: theme.spacing(7, 2),
    padding: '24px 56px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      padding: theme.spacing(2, 2),
    },
  },

  gridButton: {
    padding: 0 + '!important',
  },
  currentPlanContainer: {},
  borderBottom: {
    borderBottom: '1px solid #E5E5E5',
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: 18,
    marginBottom: theme.spacing(3),
  },
  buttonSectionFooter: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
  cancelButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      flexGrow: '1',
    },
  },
  confirmButton: {
    fontSize: 18,
    fontWeight: 600,
    minWidth: 'auto',
    width: '100%',
    marginLeft: 8,
    color: `${theme.customPalette.grapePurple} !important`,
    '&:disabled': {
      color: `white !important`,
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 218,
    },
  },
  cancelButton: {
    fontSize: 18,
    fontWeight: 600,
    minWidth: 'auto',
    width: '100%',
    padding: '8px 16px 8px 16px',
    marginRight: 8,
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 218,
    },
  },
});

const collectionTabs = (theme) => ({
  container: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  label: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  collectionContainer: {
    transform: 'translateY(1px)',
    marginTop: '16px',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  singleTab: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  collectionTab: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    width: 'auto',
    backgroundColor: 'rgba(255,255,255, .32)',
    borderRadius: '0px',
    padding: 0,
    '& :hover': {},
  },
  avatarWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& div': {
      height: '100%',
      '& img': {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        objectPosition: 'center',
      },
    },
    '& span': {
      fontFamily: 'Spezia',
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#fff',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      textTransform: 'uppercase',
      padding: '8px',
      lineHeight: 1,
    },
  },
  imgCont: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  selected: {
    backgroundColor: 'white',
    fontWeight: 600,
    borderBottom: '2px solid' + theme.customPalette.darkishPurple,
    color: `${theme.customPalette.darkishPurple}!important`,
    '& span': {
      fontWeight: 700,
      color: `${theme.customPalette.neutralGy05} !important`,
    },
  },
  indicator: {
    // backgroundColor: theme.customPalette.darkishPurple + " !important",
    display: 'none',
  },
  collectionIcon: {
    marginLeft: theme.spacing(4),
  },
  scrollButtons: { color: `${theme.customPalette.secondaryYellowYButtons}` },
});

const contactForm = (theme) => ({
  contactForm: {
    background: 'trasparent',
    '& .MuiFilledInput-root': {
      border: `2px solid ${theme.customPalette.neutralGr04} !important`,
    },
  },
  uploadTitle: {
    display: 'block',
    marginBottom: theme.spacing(2),
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  dragInputActive: {
    backgroundColor: theme.customPalette.neutralGr03,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
  },
  dragInputDeactive: {
    backgroundColor: theme.customPalette.neutralGr01,
  },
  dropzone: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  dropzoneUploadBtnTitle: {
    wordBreak: 'break-all',
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
  },
  dragInput: {
    position: 'relative',
    width: '100%',
    border: '1px dashed' + theme.customPalette.secondaryYellowYButtons,
    height: '56px',
    transition: 'all 0.4s ease-out',
    transform: 'scale(1)',
    cursor: 'pointer',
  },
  label: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  icon: {
    marginRight: theme.spacing(1),
    // transform: "rotate(180deg)",
  },
  fileAccepted: {
    fontSize: '12px',
    fontWeight: 'normal',
    fontFamily: 'Spezia',
  },

  upTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginTop: 8,
    fontFamily: 'Spezia',
  },
  input: {
    '& :placeholder': {
      fontSize: 16,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      color: theme.customPalette.neutralGr04,
    },
  },
  mainTitle: {
    fontSize: '30px',
    fontWeight: 600,
    color: theme.customPalette.black,
    fontFamily: 'Spezia',
  },
  container: {
    padding: theme.spacing(10, 0, 10, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0, 5, 0),
    },
  },
  topicSelect: {
    paddingRight: theme.spacing(0),
  },
  subscriptionSelect: {
    paddingRight: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(3),
    },
  },
  messageInput: {
    height: 'fit-content',
    width: '100%',
  },
  submitButton: {
    color: `${theme.customPalette.grapePurple} !important`,
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold !important',
    lineHeight: '16px',
    textTransform: 'capitalize',

    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 9),
  },
  placeholder: {
    color: '#aaa',
  },
});

const contactsInfo = (theme) => ({
  contactsInfo: {
    wordBreak: 'break-word',
    backgroundColor: theme.customPalette.greyClear,
    padding: theme.spacing(9, 0),
    color: theme.customPalette.black,
    fontFamily: 'Spezia',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 0),
    },
  },
  container: {
    maxWidth: 1500,
    margin: '0 auto',
    padding: theme.spacing(0, 11),
    justifyContent: 'space-around',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      padding: theme.spacing(0, 5),
    },
  },
  title: {
    fontSize: 40,
    fontWeight: 600,
    lineHeight: 1.05,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
    },
  },
  subTitle: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.1,
    maxWidth: 350,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      paddingBottom: theme.spacing(2),
    },
  },
  contactsAndQrCodeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '3em',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexDirection: 'column',
      paddingBottom: '20px',
      gap: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0',
    },
  },
  qrCodeContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
      width: '100%',
      order: 3,
    },
  },
  qrCodeImage: {
    maxWidth: '150px',
    maxHeight: '150px',
    width: 'auto',
    height: 'auto',
    display: 'flex',
    '& img': {
      objectFit: 'contain',
    },
  },
  qrCodeDescription: {
    display: 'flex',
    width: '100%',
    paddingTop: '16px',
    whiteSpace: 'pre-wrap',
    fontSize: '14px',
  },
  contactsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      paddingTop: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'flex-start',
      paddingBottom: '32px',
      paddingTop: '0',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  contacts: {
    width: 'fit-content',
  },
  firstContact: {
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 12,
    },
  },
  contact: {
    gap: '16px',
    fontSize: 18,
    fontWeight: 600,
    width: 'fit-content',
    display: 'flex',
    alignItems: 'flex-end',
    '& img': {
      width: '32px',
      height: '32px',
      [theme.breakpoints.down('xs')]: {
        width: '24px',
        height: '24px',
      },
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  whatsUpContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: '20px',
    width: 'fit-content',
  },
  whatsUpDescription: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '10px',
  },
  iconContainer: {
    backgroundColor: 'rgb(37, 211, 102)',
    padding: '10px',
    borderRadius: '50%',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageUsButton_logo: {
    width: '20px',
    height: '20px',
  },
  messageUsButton_label: {
    textDecoration: 'underline',
    color: '#000000',
  },
});

const emailCommunication = (theme) => ({
  root: {
    width: '100%',
  },
  noPadding: {
    paddingLeft: 0,
    paddingRight: 0,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  sectionTitle: {
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: '600',
    color: theme.customPalette.neutralGy05,
    display: 'block',
    marginTop: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {},
  },
  summaryContainer: {
    minHeight: 72,
  },
  details: {
    padding: '45px 57px',
  },
  formTitle: {
    marginBottom: theme.spacing(3),
    lineHeight: 1.17,
  },
  formDescription: {
    marginBottom: theme.spacing(1),
    lineHeight: 1.22,
  },
  icon: {
    marginRight: theme.spacing(2),
  },
});

const faqs = (theme) => ({
  MuiFilledInput: {
    root: {
      height: 48,
      backgroundColor: '#fff',
      border: `2px solid red !important`,
    },
  },
  faqs: {},

  upTitle: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'Spezia',
    textTransform: 'uppercase',
    marginBottom: 0,
  },

  title: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    '&:before': {
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
  },
  description: {
    marginBottom: theme.spacing(4),
  },
  expandIcon: {
    width: 24,
    height: 24,
  },
  unselected: {
    color: theme.customPalette.neutralGr02,
    [theme.breakpoints.down('sm')]: {
      color: '#999999',
    },
  },
  selectedArrow: {
    marginRight: 0,
    transform: 'rotate(90deg) origin(0,0)',
    transition: 'all .3s ease-out',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  rotateUp: {
    '-webkit-transform': 'rotate(-90deg)',
    '-ms-transform': 'rotate(-90deg)',
    transform: 'rotate(-90deg)',
  },
  rotateDown: {
    '-webkit-transform': 'rotate(90deg)',
    '-ms-transform': 'rotate(90deg)',
    transform: 'rotate(90deg)',
  },
  imageOverride: {
    // transform: "rotate(90deg)",
    transition: 'all .3s ease-out',
    transform: 'origin(0,0)',
    width: '16px',
    height: '16px',
    [theme.breakpoints.down('sm')]: {},
  },
  panelSummary: {
    border: 'none',
    [theme.breakpoints.up('sm')]: {
      border: '1px solid' + theme.customPalette.secondaryYellowYButtons,
    },
  },
  panelDetails: {
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGr05,
    backgroundColor: theme.customPalette.neutralGr01,
  },
  unselectedArrow: {
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  faq: {
    background: `#fff !important`,
    borderRadius: 0,
    marginBottom: theme.spacing(2),
    '&:first-child': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    '&:last-child': {
      marginBottom: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    [theme.breakpoints.down('sm')]: {
      borderRight: `${theme.spacing(2)}px solid white`,
      borderLeft: `${theme.spacing(2)}px solid white`,
    },
  },
  faqRoot: {},
  faqHeading: {
    margin: theme.spacing(1, 1, 1, 0),
    fontWeight: theme.typography.fontWeightBold,
  },
  answer: {},
  categories: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  category: {
    border: '1px solid' + theme.customPalette.neutralGy05,
    paddingLeft: '24px',
    paddingRight: '24px',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      border: 'none',
    },
    '& .MuiDivider-root': {
      display: 'none',
    },
  },
  categoryArrow: {
    width: 33,
    height: 31,
    marginRight: theme.spacing(1),
  },
  selected: {
    border:
      '1px solid' + theme.customPalette.secondaryYellowYButtons + '!important',
    marginRight: 0,
    height: 48,
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(1),
    },
  },
});

const faqsPrivate = (theme) => ({
  mainUpTitle: {
    fontFamily: 'Spezia',
    fontSize: 18,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
  },
  mainTitle: {
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: 500,
    color: theme.customPalette.black,
    marginTop: 0,
    marginBottom: 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
      marginBottom: theme.spacing(5),
    },
  },
  faqsContainer: {
    paddingLeft: theme.spacing(0),

    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(10),
    },
  },
  question: {
    fontSize: 20,
    fontWeight: 500,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  answer: {
    fontSize: 14,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    lineHeight: 1.17,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  faq: {
    marginBottom: theme.spacing(2),
  },
  panelSummary: {
    border: 'none',
  },
  noSubTopic: {
    fontSize: 20,
    fontWeight: '500',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
});

const footer = (theme) => ({
  footerContainer: {
    //marginTop: theme.spacing(4), // FIX ** apply margin top as default theme
    backgroundColor: theme.customPalette.black,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      //marginTop: theme.spacing(0),
    },
  },
  damIt: {
    width: '30 !important',
    height: '30 !important',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(5),
    },
  },
  logo: {
    height: '100%',
    maxWidth: 272,
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 130,
    },
  },
  socialContainer: {
    maxWidth: 1500,
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(7, 11, 4, 11),
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderColor: theme.customPalette.black,
    borderWidth: '0 0 1px 0',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      borderWidth: 0,
    },
  },
  socialTitleContainer: {
    marginTop: 'auto',
    marginBottom: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(7, 7, 4, 7),
    },
  },
  socialLinkContainer: {
    display: 'flex',
    maxWidth: 272,
    width: 'auto',
    justifyContent: 'space-between',
    marginTop: 24,
    marginLeft: 0,
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 130,
      marginBottom: 40,
      marginLeft: 'auto',
    },
  },
  iconLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: 24,
    },
  },
  accordion: {
    backgroundColor: theme.customPalette.black,
    margin: 0,
    paddingBottom: 15,
    '@media screen and (min-width: 960px)': {
      display: 'none',
    },
  },
  accordionSummary: {
    borderBottom: `1px solid ${theme.customPalette.neutralGr01}`,
    color: theme.customPalette.neutralGr01,
    padding: 0,
    '& .MuiIconButton-root': {
      color: theme.customPalette.neutralGr01,
    },
  },
  accordionSummaryHeader: {
    fontFamily: 'Spezia',
    marginTop: 0,
    fontSize: 18,
    fontWeight: 600,
  },
  '.MuiIconButton-root': {
    color: theme.customPalette.neutralGr01,
  },
  accordionDetails: {
    paddingLeft: 0,
  },
  accordionSummaryBody: {
    padding: theme.spacing(1, 0, 0, 0),
  },
  '.MuiAccordionDetails-root': {
    paddingLeft: 0,
  },
  accordionLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
  },
  accordionLinkText: {
    fontFamily: 'Spezia !important',
    textDecoration: 'none',
    color: theme.customPalette.neutralGr01,
    fontSize: 17,
  },
  chooseCountry: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    marginTop: theme.spacing(3),
    color: '#fff !important',
    fontSize: 12,
  },
  countrySelectedContainer: {
    display: 'flex',
    cursor: 'pointer',
    marginTop: 5,
  },
  countrySelected: {
    fontFamily: 'Spezia',
    color: '#fff !important',
    fontWeight: 600,
    marginLeft: 10,
    marginRight: 10,
  },
  linksTitle: {
    fontFamily: 'Spezia',
    color: theme.customPalette.primaryGreenG03,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: 600,
  },
  linkListContainer: {
    padding: '14px 0 40px 0',
    '@media screen and (max-width: 959px)': {
      display: 'none',
    },
  },
  linkList: {},
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  link: {
    width: '100%',
    textDecoration: 'none',
    color: '#fff !important',
    marginRight: 64,
    fontWeight: 'initial',
    '&:visited': {
      color: '#fff !important',
    },
  },
  linkText: {
    fontFamily: 'Spezia',
    color: '#fff !important',
    fontSize: 18,
  },
  linkTextCopyright: {
    fontFamily: 'Spezia',
    color: theme.customPalette.black,
    fontWeight: 500,
  },
  collectionLinksContainer: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  collectionChunkContainer: {
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  socialIcon: {
    display: 'flex',
    maxHeight: 38,
    justifyContent: 'center',
  },
  borderLeft: {
    borderStyle: 'solid',
    borderColor: theme.customPalette.black,
    borderWidth: '0 0 0 1px',
    paddingLeft: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      borderWidth: 0,
    },
  },
  paymentsContainer: {
    display: 'flex',
    justifyContent: 'center',
    borderStyle: 'solid',
    borderColor: theme.customPalette.black,
    backgroundColor: theme.customPalette.primaryGreenG03,
    borderWidth: '0 0 1px 0',
    padding: theme.spacing(4, 0),
  },
  paymentElement: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
  },
  paymentIcon: {
    height: 21,
    marginLeft: 14,
    marginRight: 14,
    [theme.breakpoints.down('sm')]: {
      height: 16,
      marginLeft: 7,
      marginRight: 7,
    },
  },
  lastIcon: {
    height: '34px!important',
    [theme.breakpoints.down('sm')]: {
      height: '28px!important',
    },
  },
  securePaymentContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(4),
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  securePaymentText: {
    color: theme.customPalette.black,
    whiteSpace: 'pre-line',
    paddingLeft: theme.spacing(1),
    textAlign: 'left',
    lineHeight: '1.3 !important',
  },
  copyrightContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.customPalette.primaryGreenG03,
    justifyContent: 'center',
    padding: theme.spacing(2, 0, 2, 0),
    [theme.breakpoints.only('xs')]: {
      display: 'block',
      textAlign: 'center',
    },
  },
  copyrightText: {
    display: 'flex',
    paddingBottom: 16,
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      borderBottom: `1px solid ${theme.customPalette.black}`,
      marginBottom: 8,
    },
  },
  copyrightLinks: {
    display: 'flex',
    justifyContent: 'center',
    wordBreak: 'break-word',
    overflowX: 'scroll',
  },
  copyrightElement: {
    color: theme.customPalette.black,
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  copyrightTextClass: {
    fontFamily: 'Spezia',
    fontSize: 14,
    color: theme.customPalette.black,
  },
});

const gift = (theme) => ({
  root: {},
  giftCollection: {
    backgroundColor: theme.customPalette.greyClear,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // height: 297,
    // padding: theme.spacing(4, 5, 0, 0),
    background: theme.customPalette.neutralGr02,
    // marginTop: 132,
    // marginBottom: 64,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      // margin: 0,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      // padding: theme.spacing(1, 1, 2, 1),
    },
  },
  giftButton: {
    backgroundColor: theme.customPalette.secondaryYellowYButtons,
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    minHeight: 40,
    maxWidth: '235px',
    width: '100%',
    '& p': {
      color: '#fff',
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
      // marginBottom: "-5px",
    },
  },
  imageWrapper: {
    height: '100%',
    maxWidth: '100%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
      maxHeight: '160px',
    },
  },
  boxStepper: {
    // overflowX: "scroll",
    '& ::-webkit-scrollbar': {
      display: 'none',
    },
  },
  image: {
    width: 'auto',
    height: 'auto',
    margin: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  imageContainer: {
    width: '40%',
  },
  contentContainer: {
    // width: "60%",
    // [theme.breakpoints.down("sm")]: {
    //     width: "100%",
    //     paddingLeft: 0,
    // },
    width: '100%',
    padding: '16px 0',
    [theme.breakpoints.up('sm')]: {
      padding: '32px 0',
    },
  },
  textPadding: {
    paddingLeft: '24px',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '40px',
    },
  },
  title: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    '&:before': {
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
  },
  subtitle: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  description: {
    fontFamily: 'Spezia',
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: 1.14,
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  spacing: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // "& .MuiGrid-item": {
    //     padding: theme.spacing(2),
    // },
    [theme.breakpoints.down('sm')]: {
      // "& .MuiGrid-item": {
      //     padding: theme.spacing(2),
      // },
    },
  },
  small: {
    // height: 160,
    // marginTop: 16,
    // marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    '& $image': {
      // marginTop: -48,
      maxHeight: 250,
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
    },
    '& $spacing': {
      '& .MuiGrid-item': {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.down('sm')]: {
        '& .MuiGrid-item': {
          padding: theme.spacing(1),
        },
      },
    },
  },
  mainTitle: {
    color: theme.customPalette.secondaryYellowYButtons,
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Spezia',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  giftTitle: {
    fontSize: 18,
    fontFamily: 'Spezia',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
});

const myAddresses = (theme) => ({
  root: {
    width: '100%',
  },
  sectionTitle: {
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: '600',
    color: theme.palette.neutralGy05,
    display: 'block',
    paddingTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  passwordContainer: {
    marginTop: theme.spacing(1),
  },
  avatar: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: 0,
      width: 100,
      height: 100,
    },
  },
  bigAvatar: {
    margin: theme.spacing(2, 2),
    width: 128,
    height: 128,
  },
  prefixInput: {
    width: '100% !important',
    padding: '14px 55px !important',
  },
  prefixInputContainer: {
    marginTop: 17,
  },
  isDefault: {
    backgroundColor: '#bfbfbf',
  },
});

const moreCollections = (theme) => ({
  moreProduct: {
    backgroundColor: theme.customPalette.neutralGr02,
    padding: theme.spacing(10, 0),
  },
  productsGrid: {},
  title: {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  product: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    height: 340,
    width: '100%',
    padding: theme.spacing(3),
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      height: 400,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  productImage: {
    display: 'flex',
    position: 'absolute',
    right: 0,
    bottom: 0,
    maxHeight: 340,
    maxWidth: 524,
    [theme.breakpoints.down('md')]: {
      position: 'initial',
      maxWidth: 228,
    },
  },
  small: {},
  big: {
    '&$product': {
      height: 400,
      [theme.breakpoints.down('md')]: {
        height: 400,
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        flexDirection: 'row',
      },
      [theme.breakpoints.down('xs')]: {
        height: 400,
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'column',
      },
    },
    '& $productImage': {
      [theme.breakpoints.down('md')]: {
        position: 'absolute',
        maxWidth: 524,
      },
    },
  },
});

const newsModule = (theme) => ({
  container: {
    width: '100%',
    padding: theme.spacing(0),
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(0),
    },
  },
  slider: {
    paddingLeft: theme.spacing(2),
    '& .slick-list': {
      width: `calc(100% - ${theme.spacing(2)}px)`,
    },
  },
  grid: {
    marginTop: theme.spacing(5),
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    padding: '16px',
    fontWeight: 500,
    fontSize: 16,
    marginTop: theme.spacing(5),
    width: 300,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
  },
});

const nextCollectionModal = (theme) => ({
  modal: {},
  title: {},
  modalBody: {
    minWidth: `min(60vw, ${theme.breakpoints.values.md}px)`,
    height: '100%',
    padding: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(0),
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-around',
      padding: theme.spacing(0),
    },
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: 36,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  sectionText: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: theme.spacing(5),
  },
  confirmButton: {
    minHeight: 48,
    marginBottom: theme.spacing(5),
    color: `${theme.customPalette.grapePurple} !important`,
    '&:disabled': {
      color: `white !important`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: theme.spacing(5),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  image: {
    maxHeight: 500,
    maxWidth: 960,
  },
  imageWrapper: {
    textAlign: 'center',
  },
});

const orderAlertBar = () => ({
  orderStickyAlert: {},
});

const paymentMethod = (theme) => ({
  root: {
    width: '100%',
  },
  sectionTitle: theme.profile.sectionTitle,

  passwordContainer: {
    marginTop: theme.spacing(1),
  },
  avatar: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: 0,
      width: 100,
      height: 100,
    },
  },
  bigAvatar: {
    margin: theme.spacing(2, 2),
    width: 128,
    height: 128,
  },
  summaryContainer: {
    margin: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
});

const profileInfo = (theme) => ({
  root: {
    width: '100%',
  },
  profileInfoColumn: {
    padding: theme.spacing(1, 3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  changePassContainer: {
    paddingTop: theme.spacing(4),
    alignSelf: 'flex-end',
    width: 'fit-content',
    flexBasis: 'auto',
    maxWidth: 'fit-content',
    marginLeft: 'auto',
    paddingRight: theme.spacing(0.5),
  },
  changePass: {
    color: '#494949',
    fontSize: 16,
    fontWeight: 500,
    // borderBottom: '1px solid' + theme.customPalette.secondaryYellowYButtons,
    borderBottom: '1px solid #f29100',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  inputProf: {
    width: '100%',
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: ' translate(15px, 12px) scale(0.55)',
    },
    '& .MuiFilledInput-input': {
      padding: '22px 12px 6px !important',
    },
    '& .MuiFilledInput-underline.Mui-disabled:before': {
      borderBottomStyle: 'none',
    },
  },
  indexSelect: {
    '& .MuiSelect-select': {
      padding: '22px 12px 6px !important',
      fontSize: 16,
      fontWeight: 'normal',
      color: theme.customPalette.neutralGr04,
      marginBottom: '-5px',
    },
    '& .MuiFilledInput-root': {
      borderRadius: 0,
    },
    width: '100%',
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: ' translate(15px, 12px) scale(0.55)',
    },
  },
  dateInput: {
    width: '100%',
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: 'translate(15px, 12px) scale(0.55)',
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      opacity: 0.4,
      cursor: 'pointer',
    },
    '& .MuiFilledInput-input': {
      padding: '22px 12px 6px !important',
      fontSize: 16,
      fontWeight: 'normal',
      color: theme.customPalette.neutralGr04,
    },
    '& .MuiFilledInput-root': {
      borderRadius: 0,
    },
  },
  panelActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 52,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(5),
      gap: 16,
      justifyContent: 'space-between',
    },
  },
  sectionTitle: {
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: '600',
    color: theme.palette.neutralGy05,
    display: 'block',
    marginBottom: theme.spacing(3),
  },
  col: {
    padding: theme.spacing(6, 7, 6, 7),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2, 2, 2),
    },
  },
  colPass: {
    padding: theme.spacing(3, 2, 3, 2),
  },
  colTitle: {
    padding: theme.spacing(1),
    textTransform: 'capitalize',
  },
  avatarRoot: {
    height: '100%',
    width: '100%',
  },
  summaryContainer: {
    margin: theme.spacing(0),
    alignItems: 'center',
  },
  dataContainer: {
    backgroundColor: 'red',
  },
  horizontalDivider: {
    marginTop: theme.spacing(2),
  },
  errorPhone: {
    fontSize: 12,
    color: theme.customPalette.coral,
  },
  errorPass: {
    fontSize: 12,
    color: theme.customPalette.coral,
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'left',
    padding: '16px 32px',
    [theme.breakpoints.up('sm')]: {
      padding: '16px',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  profileContainer: {
    padding: '16px 32px',
    paddingBottom: '12px',
    paddingTop: '0',
    [theme.breakpoints.up('sm')]: {
      padding: '16px',
      paddingBottom: 'auto',
      paddingTop: 'auto',
    },
  },
  avatar: {
    width: '48px',
    height: '48px',
    marginBottom: '16px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0',
    },
  },
  nameInfo: {
    paddingLeft: '0',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '16px',
    },
  },
  border: {
    // border: "none",
    border: '1px solid' + theme.customPalette.neutralGr03,
    borderTop: 'none',
  },
  panelSummaryBorder: {
    // border: "none",
    [theme.breakpoints.up('sm')]: {
      // border: "1px solid" + theme.customPalette.secondaryYellowYButtons,
    },
  },
  containerProf: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },
  panelActionsMobile: {
    padding: 32,
  },
  saveButton: {
    color: theme.customPalette.grapePurple,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '50%',
    },
  },
  cancelButton: {
    color: theme.customPalette.neutralGy05,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '50%',
      minWidth: '50%',
      justifyContent: 'center',
    },
  },
  panelActionsWrapper: {
    paddingTop: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
});

const promoFooter = (theme) => ({
  promoFooter: {
    position: 'fixed',
    left: 0,
    // transform: `translate3d(0,${threshold}px,0)`,
    width: '100%',
    zIndex: theme.zIndex.modal - 15,
    backgroundColor: '#fff',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 0,
    },
  },
  container2: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 0,
    },
  },
  divider: {
    borderLeft: `1px solid ${theme.customPalette.neutralGy05}`,
  },
  cancelButton: {
    marginRight: 24,
  },
  iconClose: {
    position: 'absolute',
    right: 16,
    top: 16,
  },
  icon: {
    width: 24,
    height: 24,
  },
  mobileContainer: {
    padding: 16,
  },
  ctaButton: {
    height: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
});

const publicContactForm = (theme) => ({
  contactForm: {
    fontFamily: 'Spezia',
  },
  dropzoneUploadBtnTitle: {
    wordBreak: 'break-all',
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
  },
  uploadTitle: {
    display: 'block',
    marginBottom: theme.spacing(2),
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  dragInputActive: {
    backgroundColor: theme.customPalette.neutralGr03,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
  },
  dragInputDeactive: {
    backgroundColor: theme.customPalette.neutralGr01,
  },
  dropzone: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  dragInput: {
    position: 'relative',
    width: '100%',
    border: '1px dashed' + theme.customPalette.secondaryYellowYButtons,
    height: '56px',
    transition: 'all 0.4s ease-out',
    transform: 'scale(1)',
    cursor: 'pointer',
  },
  label: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  icon: {
    marginRight: theme.spacing(1),
    // transform: "rotate(180deg)",
  },
  fileAccepted: {
    fontSize: '12px',
    fontWeight: 'normal',
    fontFamily: 'Spezia',
  },
  title: {
    marginBottom: theme.spacing(1),
    fontFamily: 'Spezia',
  },
  subtitle: {
    marginBottom: theme.spacing(6),
    fontFamily: 'Spezia',
  },
  smallText: {
    marginBottom: theme.spacing(0),
    fontFamily: 'Spezia',
    fontSize: 18,
    fontWeight: 'normal',
  },
  container: {
    padding: theme.spacing(10, 3, 10, 3),
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(0),
    },
  },
  upTitle: {
    fontFamily: 'Spezia',
    fontSize: '18px',
    fontWeight: '500',
    display: 'block',
  },
  divider: {
    margin: theme.spacing(8, 0),
  },
  captchaContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 24,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  paddingRight: {
    paddingRight: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(1),
    },
  },
  paddingLeft: {
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1),
    },
  },
  w100: {
    width: '100%',
  },
  subscriptionSelect: {},

  submitButton: {
    color: theme.customPalette.grapePurple,
    marginTop: theme.spacing(3),
  },
  submitButtonResponsive: {
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  placeholder: {
    color: '#aaa',
  },
  helpImage: {
    width: 56,
    height: 56,
  },
  helpTitle: {
    fontWeight: 'bold',
    fontSize: 24,
    textAlign: 'left!important',
  },
  helpTextWrapper: {
    marginLeft: 40,
  },
  helpSubTitle: {
    display: 'flex',
    fontSize: 16,
    textAlign: 'left!important',
  },
  helpLink: {
    color: theme.customPalette.secondaryYellowYButtons,
    fontWeight: 'bold',
  },
  helpTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 2,
  },
  helpContainer: {
    display: 'flex',
    minHeight: 114,
    background: theme.customPalette.neutralGr02,
    width: 1160,
    padding: '32px 40px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 1208px)': {
      width: 'auto',
      padding: 16,
      marginLeft: 24,
      marginRight: 24,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
  helpContent: {
    display: 'flex',
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  videoSlider: {
    margin: '0 3px',
  },
  messageInput: {
    '& :placeholder': {
      fontSize: 16,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      color: theme.customPalette.neutralGr04,
    },
    '& .MuiFilledInput-input': {
      fontSize: 16,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      color: theme.customPalette.neutralGr04,
    },
    '& input': {
      '& .MuiInputBase-input.MuiFilledInput-input': {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'Spezia',
        color: theme.customPalette.neutralGr04,
      },
    },
  },
  labelSelect: {
    displaY: 'block',
    textTransform: 'capitalize',
  },
  topicSelect: {
    '& .MuiSelect-select': {
      color: theme.customPalette.neutralGr04,
      fontSize: 16,
      fontWeight: 'normal',
      padding: '10px 20px',
      // marginBottom: "-5px",
    },
    '& .MuiInputLabel-filled': {
      color: theme.customPalette.neutralGr04,
      fontSize: 16,
      fontWeight: 'normal',
      // marginBottom: "-5px",
    },
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: 'translate(22px, 8px) scale(.55)',
    },
  },
});

const changeCountryModal = (theme) => ({
  backDrop: {
    backgroundColor: theme.customPalette.black,
  },
  paperProps: {
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
      marginTop: 'auto',
    },
  },
  flagImg: {
    height: 22,
  },
  flagLabel: {
    // marginBottom: "-5px",
  },
  modalHeader: {
    borderBottom: 0,
    boxShadow: '0 4px 4px 0 rgb(215 215 215 / 25%)',
    '& h5': {
      fontFamily: 'Spezia !important',
      fontSize: 20,
      fontWeight: 600,
    },
  },
  modalBody: {
    minWidth: `min(60vw, ${theme.breakpoints.values.md}px)`,
    height: '100%',
    padding: theme.spacing(7.5, 8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
    },
  },
  chooseCountryBox: {
    display: 'flex',
    border: `solid 1px ${theme.customPalette.neutralGr03}`,
    padding: `19.5px 16px`,
    marginTop: 8,
    marginBottom: 8,
    width: 336,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& span': {
      fontFamily: 'Spezia',
      fontSize: 20,
      fontWeight: 500,
      paddingLeft: 8,
    },
    '&:hover': {
      cursor: 'pointer',
      border: `solid 1px ${theme.customPalette.secondaryYellowYButtons}`,
    },
  },
});

const subscribeForm = (theme) => ({
  formContainer: {
    width: '100%',
    paddingTop: '40px',
    paddingBottom: '40px',
    background: theme.customPalette.neutralGr02,
    fontFamily: 'Spezia',
    marginTop: '40px',
    textAlign: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: 40,
    [theme.breakpoints.up('sm')]: {
      marginTop: '98px',
      paddingTop: '55px',
      paddingBottom: '55px',
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      marginBottom: 0,
    },
  },
  formText: {},
  divider: {
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  scrolletText: {
    fontSize: 10,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGr04,
    textAlign: 'left',
    display: 'block',
    lineHeight: 1,
  },
  scroller: {
    height: 64,
    width: '100%',
    margin: '0 auto',
    borderRadius: 2,
    color: '#7d7d7d',
    overflowY: 'scroll',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  purple: {
    width: 50,
    height: 4,
    borderRadius: 2,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 24,
    background: theme.customPalette.primaryGreenG02,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 32,
  },
  submitButton: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  mainTitle: {
    fontSize: 30,
    fontWeight: 600,
    color: theme.customPalette.primaryGreenG02,
    fontFamily: 'Spezia',
    marginBottom: 8,
    lineHeight: 1,
    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
      marginBottom: 16,
    },
  },
  subtitle: {
    fontFamily: 'Spezia',
    fontSize: 18,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
    marginBottom: 16,
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      marginBottom: 16,
    },
  },
  subtitleNew: {
    fontFamily: 'Spezia',
    fontSize: 18,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
    marginBottom: 16,
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      marginBottom: 32,
    },
    '& a': {
      color: theme.customPalette.neutralGy05,
      textDecorationColor: theme.customPalette.neutralGy05,
    },
    '& p': {
      margin: 0,
    },
  },
  inputCustom: {
    backgroundColor: '#fff',
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    '& :hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiFilledInput-input': {
      textAlign: 'center',
    },
  },
});

const subscriptionDetails = (theme) => ({
  root: {
    fontFamily: 'Spezia',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.customPalette.neutralGr02,
    backgroundColor: '#fff',
  },
  modal: {
    height: '100vh',
    '& .MuiDrawer-paper': {
      height: '100%',
    },
  },
  drawnerHeaderTitle: {
    border: 'none',
    borderBottom: '1px solid' + theme.customPalette.neutralGr02,
    '& p': {
      fontSize: '20px',
      fontWeight: 500,
    },
  },
  header: {
    backgroundColor: theme.customPalette.neutralGr02,
  },
  headerTitle: {
    fontSize: '20px',
    fontFamily: 'Spezia',
  },
  borderGrey: {
    borderColor: theme.customPalette.neutralGr02,
  },
  editIcon: {
    width: 24,
    height: 'auto',
  },
  premiumImg: {
    height: 80,
  },
  premiumImgContainer: {
    textAlign: 'center',
    marginTop: -30,
  },
  upgradeTitle: {
    fontSize: 18,
  },
  panelTitle: {
    color: theme.customPalette.neutralGy05,
    fontSize: '18px',
    fontWeight: 500,
    marginBottom: '8px',
  },
  label: {
    fontSize: '16px',
    color: theme.customPalette.neutralGy05,
  },
  value: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.customPalette.neutralGy05,
  },
  currentPlan: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
    display: 'block',
  },
  currentOffer: {
    display: 'block',
    fontSize: '16px',
    fontWeight: 600,
    color: theme.customPalette.black,
    [theme.breakpoints.up('sm')]: {
      fontSize: '18px',
    },
  },
  mainTitle: {
    color: theme.customPalette.neutralGy05,
    fontWeight: 600,
    fontSize: '18px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
    },
  },
  statusChip: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.customPalette.black,
  },
  currentOfferContainer: {
    padding: '10px 16px 10px 24px',
    borderBottom: '1px solid' + theme.customPalette.neutralGr02,
  },
  statusInfo: {
    fontSize: '16px',
    fontWeight: 600,
  },
  panelWrapper: {
    padding: '10px 16px 10px 24px',
    marginBottom: '30px',
  },
  infoBox: {
    // backgroundColor: theme.customPalette.neutralGr01,
  },
  upgradeAutoPaymentTitle: {
    padding: '0px 16px',
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 600,
    color: theme.customPalette.tundora,
  },
  upgradeAutoPaymentDescription: {
    padding: '0px 16px',
    fontFamily: 'Spezia',
    fontSize: 16,
    fontWeight: 'normal',
    marginBottom: 0,
  },
  btnUpgradeAutoPayment: {
    width: '100%',
    minHeight: '48px',
  },
  automaticImg: {
    marginBottom: 50,
    marginTop: 50,
  },
});

const subscriptionModal = (theme) => ({
  modal: {},
  title: {},
  modalBody: {
    padding: theme.spacing(3, 8),
  },
  modalFooter: {
    padding: theme.spacing(3, 8),
  },
  currentPlanContainer: {},
  premiumContainer: {
    backgroundColor: '#F5F5F5',
    margin: theme.spacing(3, -8),
    padding: `${theme.spacing(5)}px ${theme.spacing(3)}px`,
    [theme.breakpoints.only('xs')]: {
      padding: `${theme.spacing(5)}px ${theme.spacing(2)}px`,
    },
  },
  premiumImg: {
    height: 100,
    width: 'auto',
  },
  premiumContent: {
    backgroundColor: '#fff',
    borderRadius: 3,
    display: 'flex',
    [theme.breakpoints.only('xs')]: {
      display: 'block',
    },
  },
  premiumImgContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '20%',
    position: 'relative',
    justifyContent: 'center',
    backgroundColor: '#E5E5E5',
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  premiumTag: {
    color: '#fff',
    backgroundColor: '#32C5FF',
    border: '1px solid #fff',
    borderRadius: '100%',
    position: 'absolute',
    top: -30,
    left: 15,
    width: '60px',
    height: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    lineHeight: 1,
    fontSize: 12,
    padding: theme.spacing(1),
    transform: 'rotate(-30deg)',
  },
  premiumTextContainer: {
    padding: theme.spacing(5),
    [theme.breakpoints.only('xs')]: {
      padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
      position: 'relative',
    },
  },
  premiumButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      2,
    )}px`,
  },
  premiumButton: {
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  textIcon: {
    [theme.breakpoints.only('xs')]: {
      position: 'absolute',
      right: theme.spacing(2),
    },
  },
  label: {
    whiteSpace: 'nowrap',
  },
  addressContainer: {
    padding: theme.spacing(3),
  },
  borderBottom: {
    borderBottom: '1px solid #E5E5E5',
  },
  stopSubscription: {
    borderLeft: '1px solid #E5E5E5',
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`,
    [theme.breakpoints.only('xs')]: {
      borderLeft: 0,
      width: '100%',
      justifyContent: 'center',
    },
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: 18,
    marginBottom: theme.spacing(3),
  },
});

const tabs = (theme) => ({
  bar: {
    backgroundColor: 'white',
    boxShadow: 'none',
  },
  tabs: {
    minHeight: 'auto',
    // borderBottom: `1px solid ${theme.customPalette.neutralGr02}`,
  },
  cpTabs: {
    fontFamily: 'Spezia',
    // borderBottom: "1px solid" + theme.customPalette.neutralGr02,
    backgroundColor: '#fbfbfb',
  },
  muiTabRoot: {
    minWidth: '90px !important',
    padding: '6px 16px',
    minHeight: 40,
  },
  tab: {
    height: 76,
    textTransform: 'Capitalize',
    color: theme.customPalette.tundora,
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Spezia',
    [theme.breakpoints.up('sm')]: {
      fontSize: '18px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '60px !important',
      maxWidth: '30% !important',
    },
  },
  scrollButtons: {
    width: '30px',
    color: theme.customPalette.grapePurple,
    '&.scrollButtonsDesktop': {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
      },
    },
  },
  scrollButtonsDesktop: {
    display: 'flex',
  },
  customTabsStyle: {
    // "& .MuiTabScrollButton-root:first-child": {
    //     background: "black",
    //     color: "#fff",
    //     textDecoration: "none",
    //     paddingLeft: "20px",
    //     display: "block",
    // },
    // "& .MuiTabScrollButton-root:first-child::before": {
    //     content: "",
    //     background:
    //         "url('https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSj3XfIpf-OOJRCcWz4iN2CU3qMKVVbj0p0bRvKNGVo1U9pk_8ZIlyR8pWreA')",
    //     backgroundSize: "cover",
    //     position: "absolute",
    //     width: "20px",
    //     height: "20px",
    //     marginLeft: "-20px",
    // },
    // "& .MuiTabScrollButton-root:last-child": {
    //     background: "red",
    // },
  },
  indicator: {
    // color: "trasparent",
    // display: "none !important",
    // backgroundColor: theme.customPalette.darkishPurple + " !important",
    backgroundColor: 'transparent !important',
  },
  selected: {
    color: theme.customPalette.darkishPurple,
    '& span': {
      color: theme.customPalette.darkishPurple,
      fontSize: 14,
      [theme.breakpoints.up('sm')]: {
        fontSize: 14,
      },
    },
  },
  alignRight: {
    marginLeft: 'auto',
  },
  container: {
    display: 'block',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
});

const unsubscribeForm = (theme) => ({
  formContainer: {
    width: '100%',
  },
  iconAccordion: {
    width: '20px',
    height: '20px',
  },
  accordion: {
    border: '1px solid #d2d3d6',
    padding: 16,
    wordBreak: 'break-word',
    marginTop: 0,
  },
  marketingBoxGDPR: {
    padding: theme.spacing(2, 0, 2, 0),
    fontFamily: 'Spezia',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    wordBreak: 'break-word',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  mainTitle: {
    paddingTop: '32px',
    paddingBottom: '40px',
    fontSize: 30,
    fontWeight: 600,
    margin: 0,
    color: theme.customPalette.darkishPurple,
    fontFamily: 'Spezia',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '56px',
    },
  },
  formText: {},
  divider: {
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(2),
  },
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  // New
  marketingSelectContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(5),
    height: '100%',
    justifyContent: 'space-between',
  },
  marketingBox: {
    border: '1px solid' + theme.customPalette.neutralGr03,
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    wordBreak: 'break-word',
  },
  selectTitle: {
    fontFamily: 'Spezia',
    fontSize: '16px',
    fontWeight: 600,
  },
  description: {
    fontFamily: 'Spezia',
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
  },
  subtitleNew: {
    fontFamily: 'Spezia',
    fontSize: 18,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
    marginBottom: 16,
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      marginBottom: 32,
    },
    '& a': {
      color: theme.customPalette.neutralGy05,
      textDecorationColor: theme.customPalette.neutralGy05,
    },
    '& p': {
      margin: 0,
    },
  },

  optionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Spezia',
  },
  // Select style
  rootSelect: {
    width: 48,
    height: 31,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.customPalette.secondaryYellowYButtons,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: theme.customPalette.secondaryYellowYButtons,
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 29,
    height: 29,
  },
  track: {
    borderRadius: 30 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},

  // Dialog
  dialogMainTitle: {
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: 600,
    color: theme.customPalette.neutralGy05,
  },
  btnCancel: {
    maxWidth: '220px',
    width: '100%',
    backgroundColor: 'transparent',
    border: '1px solid' + theme.customPalette.secondaryYellowYButtons,
    padding: '18px 16px',
    '& span': {
      color: theme.customPalette.white,
    },
  },
  btnConfirm: {
    maxWidth: '220px',
    width: '100%',
    padding: '18px 16px',
    marginLeft: 8,
    '& span': {
      color: theme.customPalette.darkishPurple,
    },
  },
  dialogTitle: {
    boxShadow: '0 4px 4px 0 rgba(215, 215, 215, 0.25)',
  },
  iconDialog: {
    width: 24,
    height: 24,
  },
  dialogPaper: {
    width: '100%',
    minHeight: '100vh',
    maxHeight: '100vh',
    margin: 0,
    [theme.breakpoints.up('sm')]: {
      minHeight: '80vh',
      maxHeight: '80vh',
      margin: 16,
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
    },
  },
  boxBtnDialog: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
});

const userBanner = (theme) => ({
  root: {
    // minHeight: 233,
    color: 'white',
    fontFamily: 'Spezia',
    //backgroundColor: theme.customPalette.neutralGr02,
    backgroundColor: theme.customPalette.darkishPurple,
    [theme.breakpoints.down('xs')]: {
      // minHeight: 295,
    },
  },
  containerTabs: {
    borderBottom: `1px solid ${theme.customPalette.neutralGy05}`,
  },
  container: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    paddingTop: theme.spacing(3),
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(5),
    },
  },
  paddingNoOrder: {
    paddingBottom: '16px',
  },
  title: {
    color: 'white',
    marginBottom: theme.spacing(1),
    fontSize: '20px',
    fontWeight: 600,

    [theme.breakpoints.up('sm')]: {
      fontSize: '30px',
    },
  },
  id: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#fff',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    },
  },
  subtitle: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 500,
  },
  grid: {
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  link: {
    textTransform: 'uppercase',
  },
});

const activateProfile = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  root: {
    width: 400,
    display: 'block',
    backgroundColor: '#fff',
    padding: '30px 20px',
    borderRadius: 0,
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  title: {
    fontSize: 30,
    fontWeight: 600,
    color: theme.customPalette.neutralGy05,
    fontFamily: 'Spezia',
    margin: 0,
  },
  subtitle: {
    fontSize: 18,
    fontWeight: 'normal',
    color: theme.customPalette.neutralGy05,
    fontFamily: 'Spezia',
    marginBottom: theme.spacing(5),
  },
  input: {
    width: '100%',
  },
  errorText: {
    //FIXME
    marginTop: 8,
    fontSize: 16,
    color: '#f93f3f',
    '& a': {
      color: '#f93f3f',
    },
  },
  button: {
    width: '100%',
    fontWeight: 400,
    minHeight: 48,
    textTransform: 'capitalize',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    color: theme.customPalette.darkishPurple,
    fontSize: 16,
    fontWeight: 600,
    '& img': {
      width: 24,
      height: 24,
    },
  },
  img: {
    width: '36px',
    height: 'unset!important',
  },
  typ: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    textAlign: 'center',
  },
  missingFields: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    padding: '30px 20px',
  },
  rootTyp: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },
});

const tutorials = (theme) => ({
  package: {
    marginBottom: theme.spacing(8),
  },
  swiperButtons: {
    transform: 'translateY(-50%)',
    position: 'relative',
    zIndex: '2',
    '& button': {
      backgroundColor: 'transparent',
      border: 'none',
    },
  },
  prevIcon: {
    transform: 'rotate(180deg)',
  },
  orderSumContainer: {},
  mainTitle: {
    color: theme.customPalette.black,
    fontSize: 40,
    fontWeight: 600,
    fontFamily: 'Spezia',
    paddingTop: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(10),
    },
    maxWidth: 1280,
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingBottom: theme.spacing(4),
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  sectionTitle: {
    margin: theme.spacing(3),
  },

  collectionContainer: {
    maxWidth: 1390,
    // marginLeft: "auto",
    // marginRight: "auto",
    '@media screen and (min-width: 960px) and (max-width: 1440px)': {
      // marginLeft: theme.spacing(4),
      // marginRight: theme.spacing(4),
    },
    '@media screen and (max-width: 1440px)': {
      maxWidth: 'unset',
    },
  },
  figuresGridContainer: {},
  nextPackageContainer: {
    margin: '0px 24px',
  },
  videoClass: {
    height: 234,
    [theme.breakpoints.up('md')]: {
      height: '285px',
      width: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      height: '305px',
      width: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      height: '335px',
      width: '100%',
    },
  },
  grid: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      // padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  gridMobile: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0),
      marginBottom: theme.spacing(2),
    },
  },
  noMargin: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0!important',
    },
  },
  noMargin2: {
    marginBottom: '5px!important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0!important',
    },
  },
  selectRoot: {
    fontWeight: 400,
    padding: '0!important',
    textAlign: 'left',
    marginLeft: 8,
  },
  selector: {
    width: 225,
    [theme.breakpoints.down('sm')]: {
      marginTop: 24,
      width: '100%',
    },
  },
  title: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(7),
    padding: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
      marginBottom: 0,
    },
  },
  icon: {
    width: 32,
    height: 32,
    top: 'calc(50% - 16px)',
  },
  iconOpen: {
    '-webkit-transform': 'rotateX(180deg)',
    '-ms-transform': 'rotateX(180deg)',
    transform: 'rotateX(180deg)',
  },
  titleWrapper: {
    //marginTop: "100px",
    marginBottom: '0px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '0px',
      marginBottom: '0px',
      padding: '0px',
    },
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
    },
  },
  openVideoTutorialsContainer: {
    marginTop: theme.spacing(7),
    padding: '58px 56px',
    backgroundColor: theme.customPalette.neutralGr02,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      padding: '0 16px',
    },
    '& .MuiFilledInput-root': {
      border: `2px solid ${theme.customPalette.neutralGy05} !important`,
    },
  },
  giftBoxes: {
    paddingLeft: 50,
    paddingRight: 50,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  packageTitle: {
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'Spezia',
    margin: 0,
    color: theme.customPalette.neutralGy05,
    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  packageSequence: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    display: 'block',
  },
  videoBox: {
    padding: theme.spacing(1),
  },
  packageContainer: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(10),
    },
  },
  issuesTitle: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    display: 'block',
    paddingLeft: 8,
    paddingRight: 8,
    margin: 0,
    marginBottom: 16,
    marginTop: 24,
  },
  serviceContainer: {
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(6),
      marginTop: theme.spacing(10),
    },
  },
  spaceBottom: { marginBottom: theme.spacing(10) },
  giftBG: {
    paddingLeft: '0.5px',
    paddingRight: '0.5px',
  },
  giftsImg: {
    maxWidth: '100%',
    height: '290px',
    backgroundColor: theme.customPalette.neutralGr01,
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  giftsText: {
    backgroundColor: theme.customPalette.neutralGr02,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  giftTitle: {
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 600,
  },
  giftSubtitle: {
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 500,
  },
  instructionsGuide: {
    width: '100%',
    // height: "180px",

    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
    },
  },
  instructionsBtn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      color: theme.customPalette.darkishPurple,
      lineHeight: 1,
      paddingLeft: 8,
    },
    '& img': {
      filter: 'brightness(0) invert(1)',
    },
  },
  instructionsTitle: {
    fontSize: 20,
    color: theme.customPalette.neutralGy05,
    fontWeight: 600,
    margin: 0,
    fontFamily: 'Spezia',
  },

  instructionsDesc: {
    fontSize: 16,
    color: theme.customPalette.neutralGy05,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    margin: 0,
    marginBottom: 8,
  },
  instructionsContainer: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
});

const collection = (theme) => ({
  // NEW
  issuesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    backgroundColor: theme.customPalette.neutralGr01,
  },
  noPackageClosed: {
    backgroundColor: '#f2f2f2',
    padding: '48px 32px',
    margin: '32px 0px',
  },
  giftBG: {
    paddingLeft: '0.5px',
    paddingRight: '0.5px',
  },
  indexSelect: {
    '& .MuiSelect-select': {
      padding: '16px 20px',
      fontSize: 16,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      color: theme.customPalette.neutralGr04,
      // marginBottom: "-5px",
    },
  },
  issuesGrid: {
    flexBasis: '50%',
    [theme.breakpoints.up('sm')]: {
      flexBasis: '20%',
    },
  },
  issuesBox: {
    height: '460px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: ' center',
  },
  issuesImg: {
    maxWidth: '100%',
    height: '300px',
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  issuesName: {
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 500,
  },
  issuesLinkDetails: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.customPalette.tangerine,
    padding: '10px 0',
    wordBreak: 'break-all',
    borderRadius: '5px',
    marginTop: 16,
    '& :focus': {
      backgroundColor: theme.customPalette.brownishOrange,
    },
    '& p': {
      textTransform: 'Capitalize',
      fontFamily: 'Spezia',
      fontSize: '16px',
      fontWeight: 600,
      wordBreak: 'break-word',
      whiteSpace: 'normal',
      paddingLeft: '10px',
      paddingRight: '10px',
      color: '#fff',
    },
    '& img': {
      width: '8px !important',
      height: '8px !important',
    },
  },
  giftsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(5),
  },
  giftsImg: {
    maxWidth: '100%',
    height: '290px',
    backgroundColor: theme.customPalette.neutralGr02,
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  giftsText: {
    backgroundColor: theme.customPalette.neutralGr01,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  giftTitle: {
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 600,
  },
  giftSubtitle: {
    fontFamily: 'Spezia',
    fontSize: '20px',
    fontWeight: 500,
  },
  maiTitle: {
    fontSize: 30,
    fontWeight: 600,
    color: theme.customPalette.black,
    marginTop: '40px',
    display: 'block',
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  // OLD
  package: {
    marginBottom: theme.spacing(8),
  },
  sectionTitle: {
    margin: theme.spacing(3),
  },
  collectionContainer: {
    maxWidth: 1390,
    margin: 'auto',
  },
  figuresGridContainer: {},
  nextPackageContainer: {
    margin: '0px 24px',
  },
  extra: {
    margin: '80px auto 100px auto',
    '@media (min-width: 501px) and (max-width: 1208px)': {
      margin: '80px 16px 100px 16px',
    },
    '@media (max-width: 500px)': {
      margin: '80px 10px 100px 10px',
    },
  },
});

const helpCenter = (theme) => ({
  progress: {
    margin: '80px auto 80px auto',
  },
  cmdSelect: {
    maxWidth: '90vw !important',
    width: '100%',
  },
  faqs: {
    margin: theme.spacing(10, 0),
  },
  contactsTopicForm: {
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(5),
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(10),
    },
  },
  faqsContainer: {
    backgroundColor: theme.customPalette.neutralGr01,
    marginTop: theme.spacing('0'),
    paddingTop: theme.spacing('4'),
    paddingBottom: theme.spacing('5'),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing('5'),
      paddingTop: theme.spacing('8'),
      paddingBottom: theme.spacing('10'),
    },
  },
  topicContainer: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  topicUpTitle: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  topicMainTitle: {
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.black,
    margin: 0,
  },
  topictopicDescr: {
    fontSize: 18,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  topicSelect: {
    '& .MuiSelect-select': {
      color: theme.customPalette.neutralGr04,
      fontSize: 16,
      fontWeight: 'normal',
      // padding: "10px 20px",
      // marginBottom: "-5px",
    },
    '& .MuiInputLabel-filled': {
      color: theme.customPalette.neutralGr04,
      fontSize: 16,
      fontWeight: 'normal',
      // marginBottom: "-5px",
      // transform: "translate(20px, 16px) scale(1)",
    },
  },
});

const login = (theme) => ({
  activateYourAccountBox: {
    position: 'relative',
  },
  activateYourAccountText: {
    position: 'absolute',
    zIndex: 2,
    top: '15%',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#fff',
    width: '85%',
    textAlign: 'center',

    '& a': {
      color: theme.customPalette.secondaryYellowYButtons,
      fontWeight: 'bold',
      textDecoration: 'none',
      fontSize: 14,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
  },

  socialLoginFacebook: {
    '& img': {
      borderRadius: '50%',
      backgroundColor: '#1B74E3',
    },
  },
  divider: {
    position: 'relative',
    padding: '32px 0px',
    '& span': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      display: 'block',
      width: 100,
      textAlign: 'center',
    },
  },
  root: {
    width: 400,
    backgroundColor: '#fff',
    padding: '30px 20px',
    borderRadius: 0,
    gap: 16,
    display: 'flex',
    flexDirection: 'column',
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  iconPass: {
    width: 24,
    height: 24,
    filter:
      'invert(53%) sepia(99%) saturate(1465%) hue-rotate(14deg) brightness(96%) contrast(101%)',
  },
  secondTitle: {
    fontSize: 24,
    fontWeight: 700,
  },
  socialLogin: {
    width: '100%',
    justifyContent: 'flex-start',
    backgroundColor: '#f2f2f2',
    padding: 16,
    minHeight: '56px',
    [theme.breakpoints.down('sm')]: {},
    '&:hover': {
      backgroundColor: '#f2f2f2 !important',
    },
  },
  title: {
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    fontSize: 16,
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      fontSize: 30,
    },
  },
  input: {
    width: '100%',
    '& .MuiFilledInput-root': {
      borderRadius: 0,
    },
  },
  errorText: {
    //FIXME
    marginTop: 8,
    fontSize: 16,
    color: '#f93f3f',
  },
  forgotPass: {
    color: theme.customPalette.secondaryYellowYButtons,
    fontWeight: 'bold',
    fontSize: 14,
    marginTop: 16,
    marginBottom: 16,
  },
  forgotPasswordContainer: {
    width: 'fit-content',
    cursor: 'pointer',
    fontFamily: 'Spezia',
    fontSize: 14,
    fontWeight: 'bold',
    textDecoration: 'none',
  },
  button: {
    width: '100%',
    color: theme.customPalette.grapePurple,
    fontWeight: 400,
    minHeight: 52,
    padding: '0 16px',
    textTransform: 'none',
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 18,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
    },
    '& img': {
      width: 24,
      height: 24,
    },
  },
  keepmein: {
    fontSize: 14,
    paddingLeft: 8,
    fontFamily: 'Spezia',
  },
  keepmeinContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'start',
      gap: 14,
    },
  },
});

const loginAgent = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  root: {
    width: 400,
    display: 'block',
    backgroundColor: '#fff',
    padding: '30px 20px',
    borderRadius: 0,
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
  },
  input: {
    width: '100%',
  },
  errorText: {
    //FIXME
    marginTop: 8,
    fontSize: 16,
    color: '#f93f3f',
  },
  forgotPass: {
    color: theme.customPalette.secondaryYellowYButtons,
    fontWeight: 'bold',
    fontSize: 14,
    textDecoration: 'underline',
    marginTop: 16,
    marginBottom: 16,
  },
  forgotPasswordContainer: {
    width: 'fit-content',
    cursor: 'pointer',
  },
  button: {
    width: '100%',
    color: theme.customPalette.darkishPurple,
    fontWeight: 400,
    minHeight: 52,
    padding: '0 16px',
    textTransform: 'none',
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 18,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
    },
    '& img': {
      width: 24,
      height: 24,
    },
  },
  keepmein: {
    fontWeight: 'bold',
    fontSize: 12,
  },
  keepmeinContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-12px',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
});

const publicContactUs = (theme) => ({
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  progress: {
    margin: '80px auto 80px auto',
  },
  title: {
    textAlign: 'center',
  },
});

const publicHelpCenter = (theme) => ({
  progress: {
    margin: '120px auto 120px auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 80,
    },
  },
  faqs: {
    margin: theme.spacing(15, 0, 20, 0),
  },
  title: {
    fontFamily: 'Spezia',
    textAlign: 'center',
    width: '100%',
  },
  banner: {
    marginTop: theme.spacing(15),
    /*        display: "flex",
        alignItems: "center",
        maxHeight: 447,
        minHeight: 360,
        height: "100%",
        width: "100%"*/
  },
});

const resetPassword = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
  },
  root: {
    width: 400,
    display: 'block',
    backgroundColor: '#fff',
    padding: '30px 20px',
    borderRadius: 0,
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  title: {
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    marginBottom: theme.spacing(5),
  },
  typ: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
  },
  input: {
    width: '100%',
  },
  errorText: {
    //FIXME
    marginTop: 8,
    fontSize: 16,
    color: '#f93f3f',
  },
  successBox: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    maxWidth: '36px !important',
    height: '36px !important',
  },
  button: {
    width: '100%',
    fontWeight: 400,
    minHeight: 48,
    textTransform: 'capitalize',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    color: theme.customPalette.grapePurple,
    '&:disabled': {
      color: '#FFF',
    },
    '& span': {
      fontSize: 18,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
      '& img': {
        width: 24,
        height: 24,
      },
    },
  },
});

const subscription = (theme) => ({
  package: {
    marginBottom: theme.spacing(8),
  },
  paddingRightRE: {
    paddingRight: 0,
    [theme.breakpoints.up('sm')]: {
      paddingRight: '14%',
    },
  },
  paddingContainer: {
    paddingBottom: theme.spacing(5),
  },
  modelAccordionSummary: {
    position: 'absolute',
    top: '100%',
    left: 0,
    minHeight: '48px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
    border: '1px solid' + theme.customPalette.neutralGr03,
    borderTop: 'none',
    width: '100%',
  },
  sectionTitle: {
    margin: theme.spacing(6, 0, 5, 0),
    fontFamily: 'Spezia',
    fontSize: 30,
    fontWeight: 600,
    color: theme.customPalette.black,
    marginBottom: 24,
    marginTop: 24,
    display: 'block',
  },
  wrapper: {
    display: 'flex',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  accordionStyle: {},
  accordionSummary: {
    fontFamily: 'Spezia',
    border: '0.5px solid' + theme.customPalette.neutralGr04,
  },
  accordionDetails: {
    border: '0.5px solid' + theme.customPalette.neutralGr04,
    borderTop: 'none',
    padding: '0',
  },
  shipmentsWrapper: {
    width: '70%',
    paddingRight: theme.spacing(15),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  subscriptionWrapper: {
    // width: "30%",
    // [theme.breakpoints.down("sm")]: {
    //     width: "100%",
    // },
    // marginTop: theme.spacing(13),
  },
  packagesGrid: {
    paddingRight: theme.spacing(0),
    [theme.breakpoints.up('md')]: {
      paddingRight: theme.spacing(16),
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(18),
    },
    [theme.breakpoints.up('xl')]: {
      paddingRight: theme.spacing(20),
    },
  },
  nextShipBox: {
    paddingLeft: '16px',
    paddingRight: '16px',
    backgroundColor: theme.customPalette.neutralGr01,

    [theme.breakpoints.up('sm')]: {
      paddingLeft: '24px',
      paddingRight: '24px',
      backgroundColor: '#fff',
    },
  },
  stepperBox: {
    backgroundColor: 'transparent !important',
    transform: 'translateY(5%)',
    paddingRight: '0',
    paddingLeft: '0',
    '& .MuiStepConnector-alternativeLabel': {
      backgroundColor: theme.customPalette.neutralGr03,
      // left: "calc(-30% + 20px)",
      // right: "calc(70% + 20px)",
      height: '1px',
    },
    '& .MuiStep-alternativeLabel': {
      '& span': {
        transform: 'translateY(-5%)',
        border: 'none',
      },
    },
    '& .MuiStepConnector-alternativeLabel.Mui-disabled': {
      backgroundColor: theme.customPalette.neutralGr03,
    },
    '& .MuiStepConnector-alternativeLabel.MuiStepConnector-completed': {
      backgroundColor: theme.customPalette.secondaryYellowYButtons,
    },
    '& .MuiStepConnector-alternativeLabel.MuiStepConnector-active': {
      backgroundColor: theme.customPalette.secondaryYellowYButtons,
    },
  },
  nextShipTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  nextShipTracking: {
    '& p': {
      color: theme.customPalette.secondaryYellowYButtons,
      fontSize: '10px',
      fontWeight: 'bold',
      border: 'none',
      textTransform: 'capitalize',
    },
  },

  // Full Kit
  fullKit: {
    backgroundColor: theme.customPalette.neutralGr01,
  },
  fullKitContainer: {
    padding: theme.spacing(7),
  },
  FKMainTitle: {
    fontSize: 40,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  videoClass: {
    height: 234,
    [theme.breakpoints.up('md')]: {
      height: '285px',
      width: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      height: '305px',
      width: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      height: '335px',
      width: '100%',
    },
  },
  assembledTitle: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  assembledContent: {
    maxWidth: '220px',
    width: '100%',
    textAlign: 'right',
  },
  serviceBox: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
  },
});

const unsubscribe = (theme) => ({
  container: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      maxWidth: 960,
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(10),
    },
  },
  title: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  select: {
    width: '50%',
  },
  subtitle: {
    fontSize: 16,
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
    },
  },
  dialogTitle: {
    boxShadow: '0 4px 4px 0 rgba(215, 215, 215, 0.25)',
  },
  iconDialog: {
    width: 24,
    height: 24,
  },
  dialogPaper: {
    // width: '100%',
    // minHeight: '100vh',
    // maxHeight: '100vh',
    margin: 0,
    [theme.breakpoints.up('sm')]: {
      // minHeight: '80vh',
      margin: 16,
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
    },
  },
  boxBtnDialog: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
});

const infoBar = (theme) => ({
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    background: theme.customPalette.secondaryBlueB02,
    color: 'white',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: 48,
    maxWidth: 740,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: 10,
    paddingBottom: 10,
    '@media (min-width: 992px)': {
      maxWidth: 960,
      padding: 0,
    },
    '@media (min-width: 1200px)': {
      maxWidth: 1140,
      padding: 0,
    },
    '@media (min-width: 1600px)': {
      maxWidth: 1280,
      padding: 0,
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //width: 104,
    //height: 65,
    minHeight: 65,
    //minWidth: 104,
    marginTop: -1,
    marginLeft: 18,
  },
  icon: {
    width: 24,
    height: 24,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    //marginLeft: theme.spacing(3),
  },
  title: {
    color: '#fff',
  },
  linkClose: {
    '& p': {
      color: '#fff',
    },
  },
  message: {
    color: '#fff',
    fontSize: '13px',
    '& a': {
      color: '#fff',
    },
  },
  actionsWrapper: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: theme.spacing(3),
  },
  /* Styles applied to the root element if `severity="error"`*/
  severityError: {
    '& $container': {
      border: `2px solid ${theme.customPalette.secondaryPinkP02}`,
    },
    '& $iconWrapper': {
      backgroundColor: theme.customPalette.secondaryPinkP02,
    },
  },
});

const dashboard = (theme) => ({
  containerProducts: {
    //border: "2px solid #336699",
    marginTop: '30px',
    marginBottom: '30px',
  },

  /* Products */
  box50: {
    position: 'relative',
    //border: "1px solid green",
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(50% - 10px)',
      overflowY: 'hidden',
    },
    float: 'left',
    height: '460px',
  },
  box50image: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  box50content: {
    position: 'relative !important',
    top: 0,
    left: 15,
    flexDirection: 'column',
    justifyContent: 'space-between',
    display: 'flex',
    paddingBottom: '32px',
    height: '100%',
    maxHeight: '460px',
    width: 'calc(100% - 20px)',
  },
  box50contentLogo: {
    marginTop: 15,
    maxHeight: '70px',
    width: '100%',
    //border: "1px solid #ff0000"
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100%',
    },
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
      objectPosition: 'left',
    },
  },
  box100contentLogo: {
    marginTop: 15,
    maxHeight: '95px',
    width: '100%',
    //border: "1px solid #ff0000"
    display: 'flex',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%%',
    },
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  box100logo: {},
  box50logo: {
    height: '100%',
  },
  containerEven: {
    marginRight: '0px',
    marginLeft: '0px',
    marginBottom: '20px',
    [theme.breakpoints.up('sm')]: {
      marginRight: '0px',
      marginLeft: '10px',
    },
  },
  containerOdd: {
    marginLeft: '0px',
    marginRight: '0px',
    marginBottom: '20px',
    [theme.breakpoints.up('sm')]: {
      marginLeft: '0px',
      marginRight: '10px',
    },
  },

  /** Pages */
  containerPages: {
    //border: "2px solid #336699",
    marginTop: '30px',
    marginBottom: '30px',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'center',
  },
  box33: {
    flexBasis: 'calc(100% / 3)',
    maxWidth: 'calc(100% / 3)',
  },
  box33content: {
    marginBottom: '5px',
    marginTop: '5px',
    paddingLeft: '5px',
    paddingRight: '5px',
  },

  resetFloat: {
    clear: 'both',
  },

  card_50: {
    height: 460,
    position: 'relative',
    // padding: "30px 24px",
    [theme.breakpoints.down('sm')]: {
      height: 500,
    },
  },
  card_100: {
    // padding: "60px 120px",
    height: 460,
    position: 'relative',
    // padding: "30px 24px",
    // [theme.breakpoints.down("sm")]: {
    //     padding: "20px 24px",
    // },
    [theme.breakpoints.down('sm')]: {
      height: 500,
    },
  },
  boxText__100: {
    padding: '60px 120px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 24px',
    },
  },
  imgContainer: {
    width: '100%',
    height: '100%',
    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
      objectPosition: 'center',
    },
  },
  boxText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
  boxText__50: {
    padding: '24px 24px 48px',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 16px',
    },
  },
  newLabel: {
    color: theme.customPalette.secondaryPinkP01,
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Spezia',
    display: 'block',
  },
  cardTitle: {
    color: '#fff',
    fontWeight: 'bold',
    fontFamily: 'Spezia',
    margin: '0',
  },
  cardTitle100: {
    color: '#fff',
    fontSize: 35,
    fontWeight: 'bold',
    margin: '0',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  cardTitle50: {
    color: '#fff',
    fontSize: 30,
    fontWeight: 'bold',
    margin: '0',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  btnLabel: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'Spezia',
    // [theme.breakpoints.down("sm")]: {
    //     fontSize: 14,
    // },
  },
  categoryCard: {
    textDecoration: 'none',
  },
});

const app = (theme) => ({
  btnPopup: {
    color: `${theme.customPalette.grapePurple} !important`,
    fontSize: 16,
    maxWidth: '218px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  alertCompleteProfile: {
    width: '100%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    justifyContent: 'center',
    padding: '16px 32px',
    backgroundColor: '#396dcf',
    flexDirection: 'row',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('md')]: {
      gap: '12px',
    },
    '& .completeProfileText': {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
      },
    },
    '& .completeProfileMessage': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: '32px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '8px',
      },
    },
    '& .completeProfileTitle': {
      fontSize: '14px',
    },
    '& .completeProfileSubtitle': {
      fontSize: '12px',
    },
    '& .completeProfileButton': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .completeButton': {
      fontWeight: 'bold',
      color: 'white',
      borderColor: 'white',
      '&:hover': {
        color: `${theme.customPalette.grapePurple} !important`,
      },
    },
    '&.centeredProfileAlert': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  alertCompleteProfileWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: 32,
  },
  alertCP: {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#396dcf',
    flexDirection: 'row',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  description: {
    fontSize: 14,
    color: theme.customPalette.neutralGy05,
    fontWeight: 'normal',
  },
  marketingBoxGDPR: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
    '& p': {
      margin: 0,
    },
  },
  modal: {
    height: '100vh',
    '& .MuiDrawer-paper': {
      height: '100%',
    },
  },
  drawerContent: {
    width: '50vw',
    height: '50%',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
    },
  },
  drawnerHeaderTitle: {
    border: 'none',
    borderBottom: '1px solid' + theme.customPalette.neutralGr02,
    '& p': {
      fontSize: '20px',
      fontWeight: 500,
    },
  },
  modalContainer: {
    width: '100%',
    height: 'auto',
  },
  headerTitle: {
    fontSize: '20px',
    fontWeight: 600,
  },
  mainTitleDialog: {
    fontSize: '30px',
    fontWeight: 600,
    color: theme.customPalette.neutralGy05,
    marginBottom: 24,
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
  },
  odio: {
    color: '#000',
    fontSize: 16,
    fontWeight: 'normal',
  },
  boxContent: {
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  iconTitle: {
    color: theme.customPalette.neutralGy05,
    marginBottom: '-5px',
    fontSize: '20px',
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
    },
  },
  root: {
    position: 'relative',
    minHeight: '100vh',
  },
  stickyStack: {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar,
  },
  main: {
    backgroundColor: theme.customPalette.white,
    flexGrow: 1,
    paddingTop: 25,
  },
  fullScreenProgerss: {},
  whatsappContainer: {
    border: 0,
    position: 'fixed',
    zIndex: '50',
    bottom: '150px',
    right: 0,
    margin: '10px 20px',
  },
  messageUsButton_container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'stretch',
    position: 'relative',
  },
  messageUsButton: {
    width: '100%',
    justifyContent: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Arial, sans-serif',
    fontWeight: '500',
    lineHeight: 0,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    border: '1px solid transparent',
    borderRadius: '999rem',
    backgroundColor: 'rgb(37, 211, 102)',
    color: 'rgb(255, 255, 255)',
    fontSize: '15px',
    padding: '15px',
  },
  messageUsButton_logo: {
    marginRight: '8px',
  },
  messageUsButton_label: {
    border: '1px solid transparent',
    borderRadius: '999rem',
    backgroundColor: 'rgb(37, 211, 102)',
    color: 'rgb(255, 255, 255)',
    fontSize: '15px',
  },
});

const service = (theme) => ({
  mainTitle: {
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    marginBottom: 8,
  },
  description: {
    fontSize: 20,
    fontWeight: 'normal',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
    marginBottom: 24,
  },
  btnText: {
    fontSize: 20,
    fontWeight: 500,
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  box: {
    border: '1px solid' + theme.customPalette.black,
    padding: '8px 16px',
    '& a': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      textDecoration: 'none',
      width: '100%',
      height: '100%',
    },
  },
  icon: {
    width: 24,
    height: 24,
  },
});

const packageFullKit = (theme) => ({
  fullKitContainer: {
    [theme.breakpoints.up('sm')]: {},
  },
  stepperBg: {
    backgroundColor: theme.customPalette.neutralGr01,
    padding: '16px 8px',
  },
  accordionSummary: {
    backgroundColor: theme.customPalette.neutralGr02,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  summaryTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Spezia',
    color: theme.customPalette.neutralGy05,
  },
  accordionDetails: {
    backgroundColor: '#fff',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 10),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 15),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(5, 20),
    },
  },
  trackingUrl: {
    marginTop: '5px',
    justifyContent: 'start',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'end',
    },
    '& p': {
      color: '#494949',
      fontSize: '10px',
      fontWeight: 'bold',
      border: 'none',
      textDecoration: 'underline',
      textDecorationColor: theme.customPalette.secondaryYellowYButtons,
      textUnderlineOffset: '2px',
      textTransform: 'capitalize',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',

    '& .MuiListItemText-primary': {
      color: theme.customPalette.neutralGy05,
      fontSize: 14,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      flexBasis: '100%',
      wordBreak: 'break-word',
    },
    '& .MuiListItemText-secondary': {
      color: theme.customPalette.neutralGy05,
      fontSize: 16,
      fontWeight: 500,
      fontFamily: 'Spezia',
      flexBasis: '100%',
      wordBreak: 'break-word',
      '& b': {
        textTransform: 'capitalize',
      },
    },
  },
  imgContainer: {
    width: '100%',
    maxHeight: 400,
    height: '100%',
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
      objectPosition: 'center',
    },
  },
  giftMainTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.customPalette.black,
    fontFamily: 'Spezia',
    margin: 0,
  },
  giftDesc: {
    fontSize: 16,
    fontWeight: 'normal',
    color: theme.customPalette.neutralGy05,
    fontFamily: 'Spezia',
    margin: 0,
  },
  giftImg: {
    maxHeight: 215,
    // height: "100%",
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  giftImgSmall: {
    // height: "100%",
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },
  giftBtn: {
    backgroundColor: theme.customPalette.secondaryYellowYButtons,
    color: '#fff',
    maxWidth: 280,
    width: '100%',
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 8px',
    '& span': {
      paddingLeft: '4px',
      lineHeight: 1,
    },
  },
  giftBox: {
    backgroundColor: theme.customPalette.neutralGr02,
  },
  buttonCustom: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),

    backgroundColor: theme.customPalette.secondaryYellowYButtons,
    border: '1px solid' + theme.customPalette.secondaryYellowYButtons,
  },
  invoiceText: {
    color: '#fff',
  },
  iconDownload: {
    width: '22px',
    height: '22px',
    filter:
      'brightness(0) saturate(100%) invert(20%) sepia(53%) saturate(2487%) hue-rotate(271deg) brightness(92%) contrast(92%)',
  },
  bgGift: {
    backgroundColor: theme.customPalette.neutralGr02,
  },
  bgLayout: {
    display: 'flex',
    // flexDirection: "column",
    [theme.breakpoints.up('sm')]: {
      // flexDirection: "row",
      alignItems: 'flex-start',
    },
  },
  bgLayoutWithDesc: {
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  bgLayoutWithNoDesc: {
    flexDirection: 'column',
  },
});

const packageRegular = (theme) => ({
  border: '10px solid #336699',
  accordionSummary: {
    border: '1px solid' + theme.customPalette.neutralGr04,
    backgroundColor: '#fff',
  },
  paymentAction: {
    maxWidth: '180px',
    width: '100%',
    '& span': {
      fontSize: 16,
      fontFamily: 'Spezia',
      fontWeight: 'bold',
      color: theme.customPalette.grapePurple,
    },
  },
  accordion: {
    marginTop: 8,
    marginBottom: 'calc(16 + 57)px',
  },
  accordionDetails: {
    border: '1px solid' + theme.customPalette.neutralGr04,
    borderTop: 'none',
    backgroundColor: '#fffff',
    padding: 0,
  },
  orderSequence: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
  },
  modelAccordionSummary: {
    position: 'absolute',
    top: '100%',
    left: 0,
    minHeight: '48px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
    border: '1px solid' + theme.customPalette.neutralGr03,
    borderTop: 'none',
    width: '100%',
    // overflowX: "scroll",
    wordBreak: 'break-word',
    fontSize: '.8rem',
    '& span': {
      fontSize: 14,
      fontFamily: 'Spezia',
      fontWeight: 'normal',
      flexDirection: 'column',
      display: 'flex',
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    '& b': {
      fontSize: 14,
      fontFamily: 'Spezia',
      fontWeight: '500',
    },
  },
  trackingUrl: {
    marginTop: '5px',
    justifyContent: 'start',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'end',
    },
    '& p': {
      color: '#494949',
      fontSize: '10px',
      fontWeight: 'bold',
      border: 'none',
      textDecoration: 'underline',
      textDecorationColor: theme.customPalette.secondaryYellowYButtons,
      textUnderlineOffset: '2px',
      textTransform: 'capitalize',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
      },
    },
  },
  warningNotPaid: {
    backgroundColor: theme.customPalette.secondaryPinkP01,
    padding: '16px',
    color: '#fff',
    '& span': {
      paddingLeft: '16px',
      fontSize: 14,
      fontWeight: 'normal',
      fontFamily: 'Spezia',
      lineHeight: 1.14,
      [theme.breakpoints.up('sm')]: {},
    },
  },
  stepperContainer: {
    overflowX: 'hidden',
    backgroundColor: theme.customPalette.neutralGr02,
    flexDirection: 'column',
    paddingBottom: 8,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      paddingBottom: 0,
    },
    '& span': {
      fontSize: '14px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.650rem',
      },
    },
    '& ::-webkit-scrollbar': {
      display: 'none',
    },
    '&:hover': {
      overflowX: 'auto',
    },
  },
  listItem: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  purchasedItem: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: 0,
    paddingBottom: 0,
    '& .MuiListItemText-root': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  price: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: '5px',
    },

    '& .MuiListItemText-primary': {
      fontSize: '14px',
      fontWeight: '500',
      color: theme.customPalette.neutralGy05,
    },
    '& .MuiListItemText-secondary': {
      fontSize: '12px',
      fontWeight: 'normal',
      color: theme.customPalette.black,
      display: 'flex',
      textAlign: 'left',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px',
        textAlign: 'right',
      },
    },
  },
  deliveryItemText: {
    display: 'flex',
    alignItems: 'start',
    gap: '5px',
    wordBreak: 'keep-all',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
      alignItems: 'end',
    },
  },
  deliveryItemTextExpanded: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '5px',
    wordBreak: 'keep-all',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
      alignItems: 'end',
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  totalPopUpContainer: {},
  tooltip: {
    minWidth: 259,
    padding: '16px 12px',
    boxShadow: 'none',
    backgroundColor: theme.customPalette.greyClear,
    color: theme.customPalette.black,
    border: `1px solid ${theme.customPalette.secondaryPinkP01}`,
    borderRadius: '12px',
    marginTop: '14px',
  },
  tooltipArrow: {
    color: theme.customPalette.secondaryPinkP01,
  },
  icon: {
    height: 16,
    width: 16,
    cursor: 'pointer',
  },
  iconContainer: {
    marginLeft: 10,
    height: 16,
    width: 16,
  },
  dialogContent: {
    margin: 16,
  },
  invoiceText: {
    color: theme.customPalette.darkishPurple,
    fontSize: 14,
    fontWeight: 600,
    fontFamily: 'Spezia',
    paddingLeft: 16,
  },
  buttonCustom: {
    backgroundColor: theme.customPalette.secondaryYellowY04,
    height: '40px',
    maxWidth: '225px',
    width: '100%',
    lineHeight: 1.2,
  },
  iconDownload: {
    width: '22px',
    height: '22px',
    filter:
      'brightness(0) saturate(100%) invert(20%) sepia(53%) saturate(2487%) hue-rotate(271deg) brightness(92%) contrast(92%)',
  },
  mainTitle: {
    color: theme.customPalette.black,
    fontSize: '20px',
    fontWeight: 600,
    fontFamily: 'Spezia',
  },

  missingPackage: {
    '&-left': {
      padding: '20px',
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        padding: '20px 20px 0',
      },
    },
    '&-right': {
      padding: '20px',
      textAlign: 'right',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        padding: '0 20px 20px',
      },
    },
  },
  mainLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    marginBottom: '8px',
  },
  nextShipmentBanner: {
    width: '100%',
    backgroundColor: theme.customPalette.neutralGr02,
    '& > h3': {
      fontSize: '20px',
      fontWeight: 600,
      margin: '0 0 5px',
    },
    '& > p': {
      fontSize: '18px',
      fontWeight: 300,
      margin: 0,
    },
  },
});

export const reactivationCampaign = (theme) => ({
  root: {
    fontFamily: 'Spezia',
    margin: '80px auto',
    maxWidth: 1500,
    padding: theme.spacing(0, 9),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 6),
    },
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
    alignItems: 'flex-start',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(8),
      gridTemplateColumns: '1fr 1fr',
    },
  },
  imageContainer: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 85,
    },
  },
  image: {
    maxHeight: 512,
    objectFit: 'contain',
    margin: '0 auto',
  },
  title: {
    fontSize: 30,
    lineHeight: '34px',
    fontWeight: 600,
    color: theme.customPalette.darkishPurple,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 38,
      lineHeight: '42px',
      textAlign: 'left',
    },
  },
  content: {
    fontSize: 18,
    lineHeight: '24px',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      lineHeight: '28px',
      textAlign: 'left',
    },
  },
  paymentTitle: {
    fontSize: 14,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      textAlign: 'left',
    },
  },
  paymentSuccessMessage: {
    color: theme.customPalette.secondaryYellowYButtons,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      textAlign: 'left',
    },
  },
  paymentSuccessIcon: {
    color: theme.customPalette.primaryGreenG02,
  },
  terms: {
    userSelect: 'none',
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    margin: '0 auto',
    padding: '5px',
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
    '& label': {
      fontSize: 12,
      [theme.breakpoints.up('md')]: {
        fontSize: 14,
      },
    },
  },
  button: {
    width: '100%',
    maxWidth: '500px',
    margin: '0 auto',
    fontWeight: 400,
    minHeight: 52,
    padding: '20px 16px',
    textTransform: 'none',
    color: theme.customPalette.grapePurple,
    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth: '100%',
      margin: '0 auto',
    },
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 18,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
    },
    '& img': {
      width: 24,
      height: 24,
    },
  },
  boxPassive: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      alignItems: 'start',
    },
  },
  changePaymentLink: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    fontWeight: 700,
    textDecoration: 'underline',
    color: theme.customPalette.darkishPurple,
    cursor: 'pointer',
  },
  gridIcons: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(4),
    width: '100%',
    textAlign: 'center',
    padding: theme.spacing(4, 0),
  },
  iconContainer: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    fontWeight: 700,
  },
  iconImage: {
    width: 48,
    margin: '0 auto',
  },
});

const crossLoginButton = (theme) => ({
  root: {
    padding: '32px 20px 0',
    width: 400,
    backgroundColor: '#fff',
    borderRadius: 0,
    gap: 16,
    display: 'flex',
    flexDirection: 'column',
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  container: {
    border: `1px solid ${theme.customPalette.darkishPurple}`,
    padding: '16px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  label: {
    fontFamily: 'Spezia',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '.17px',
    color: theme.customPalette.darkishPurple,
  },
  button: {
    width: '100%',
    fontWeight: 400,
    minHeight: 52,
    padding: '0 16px',
    textTransform: 'none',
    color: theme.customPalette.grapePurple,
    '& .MuiButton-label': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 18,
      fontWeight: 'bold',
      fontFamily: 'Spezia',
    },
    '& img': {
      width: 24,
      height: 24,
    },
  },
});

const withdraw = (theme) => ({
  root: {
    '& .MuiSelect-filled.MuiSelect-filled': {
      paddingRight: '32px',
      fontSize: '16px',
      fontFamily: 'Spezia',
      fontWeight: 'normal',
      marginBottom: '-5px',
    },
  },
  container: {
    display: 'flex',
    maxWidth: '912px',
    margin: '0 auto',
    padding: '40px 0',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '40px',
    },
  },
  title: {
    color: theme.customPalette.darkishPurple,
    margin: 0,
    fontFamily: 'Spezia',
    fontSize: '30px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.171px',
  },
  description: {
    color: '#000',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  note: {
    margin: 0,
    color: theme.customPalette.neutralGy05,
    fontFamily: 'Spezia',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
});

const withdrawButton = (theme) => ({
  root: {
    display: 'flex',
    minHeight: 46,
    padding: theme.spacing(2, 6),
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.customPalette.darkishPurple,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '16px',
    marginTop: theme.spacing(4),
    width: '100%',
    maxWidth: 331,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
});

const appStyles = {
  packageRegular,
  paymentResult,
  packageFullKit,
  service,
  dashboard,
  addressList,
  alert,
  alertBar,
  articleCard,
  assembleHelp,
  autocomplete,
  button,
  countdown,
  dialog,
  drawerHeader,
  drawer,
  editablePanelSummaryActions,
  editablePanelRadio,
  editablePanelSummary,
  editablePanelDetails,
  editablePanelActions,
  editablePanel,
  estimatedArrival,
  figureCard,
  figureGrid,
  figureSelector,
  fixedMobileCTA,
  fluidImage,
  gallery,
  giftList,
  giftOverlay,
  iconButton,
  image,
  infoCard,
  infoCards,
  input,
  link,
  linkButton,
  logo,
  profileButton,
  mobileSlider,
  module,
  nextGift,
  nextPackageDetails,
  overlay,
  payment,
  paymentList,
  playButton,
  profileElement,
  progress,
  ribbon,
  select,
  slider,
  socialBox,
  stamp,
  statusChip,
  subscriptionHeader,
  text,
  topSpacing,
  video,
  videoDescription,
  complexItemCard,
  packageHeader,
  packageItemCard,
  nextPackage,
  notification,
  packagePackage,
  packageStepper,
  packageStatusDetails,
  aboutModule,
  assembleVideoBanner,
  appBar,
  changeAddressModal,
  changeCountryModal,
  changePaymentMethodModal,
  collectionTabs,
  contactForm,
  contactsInfo,
  emailCommunication,
  faqs,
  faqsPrivate,
  footer,
  gift,
  myAddresses,
  moreCollections,
  newsModule,
  nextCollectionModal,
  orderAlertBar,
  paymentMethod,
  profileInfo,
  promoFooter,
  publicContactForm,
  subscribeForm,
  subscriptionDetails,
  subscriptionModal,
  tabs,
  unsubscribeForm,
  userBanner,
  activateProfile,
  tutorials,
  collection,
  helpCenter,
  login,
  loginAgent,
  publicContactUs,
  publicHelpCenter,
  resetPassword,
  subscription,
  unsubscribe,
  app,
  infoBar,
  reactivationCampaign,
  crossLoginButton,
  withdraw,
  withdrawButton,
};

export default appStyles;
